<template>
<div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <onaydialog ref="onaydialog"></onaydialog>
    <snackbarcomp v-bind:mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>

    <v-form>
        <v-card color="grey lighten-5">
            <v-layout row wrap>
                <v-flex xs12 sm12>
                    <v-toolbar size="120px" dark color="info">
                        <v-toolbar-title> {{sayfabaslik}}</v-toolbar-title>
                        <v-spacer></v-spacer>

                        <v-tooltip bottom>
                            <v-btn v-if="kaydetbuton" :disabled="!sayfayetki.Save" slot="activator" @click="Kaydet()" flat> <span class="hidden-sm-and-down"> {{$t("save_button")}}
                                </span>
                                <v-icon right dark>add_box</v-icon>
                            </v-btn>
                            <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                            <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <v-btn v-if="guncellebuton" :disabled="!sayfayetki.Update || guncelledisabled" slot="activator" @click="FaturaGuncelle()" flat> <span class="hidden-sm-and-down"> {{ $t('Update') }}
                                </span>
                                <v-icon color="white" right dark>create</v-icon>
                            </v-btn>
                            <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                            <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
                        </v-tooltip>

                        <v-btn @click="Yazdir()" v-if="yazdirbtngoster" flat> <span class="hidden-sm-and-down"> {{ $t('Print') }} </span>
                            <v-icon right dark>print</v-icon>

                        </v-btn>
                        <!-- OCR butonu + gizli dosya inputu -->
<v-btn flat @click="openOcr">
  <span class="hidden-sm-and-down">PDF yükle (beta)</span>
  <v-icon right dark>file_upload</v-icon>
</v-btn>
<input ref="ocrFile" type="file" accept=".pdf,.png,.jpg,.jpeg" style="display:none" @change="handleOcrFile">


                        <v-menu offset-y>
                            <v-btn slot="activator" dark icon>
                                <v-icon>more_vert</v-icon>
                            </v-btn>
                            <v-list>

                                <v-tooltip bottom>
                                    <v-list-tile v-if="guncellebuton" slot="activator" :disabled="!sayfayetki.Delete" @click="faturasilsor()">
                                        <v-list-tile-title> {{ $t('Delete-Invoice') }} </v-list-tile-title>
                                    </v-list-tile>
                                    <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Delete"> {{ $t('Delete-Invoice') }} </span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <v-list-tile v-if="guncellebuton" slot="activator" :disabled="!sayfayetki.Update || guncelledisabled" @click="faturanotarihdegistir(0)">
                                        <v-list-tile-title> {{ $t('Change-Invoice-Number') }} </v-list-tile-title>
                                    </v-list-tile>
                                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Update"> {{ $t('Change-Invoice-Number') }} </span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <v-list-tile v-if="guncellebuton" slot="activator" :disabled="!sayfayetki.Update || guncelledisabled" @click="faturanotarihdegistir(1)">
                                        <v-list-tile-title> {{ $t('Change-Invoice-Date') }} </v-list-tile-title>
                                    </v-list-tile>
                                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Update"> {{ $t('Change-Invoice-Date') }} </span>
                                </v-tooltip>

                                <a target="_self" v-bind:href="'#/faturalar/faturalistesi'">
                                    <v-list-tile>
                                        <v-list-tile-title> {{ $t('Leave') }} </v-list-tile-title>
                                    </v-list-tile>
                                </a>
                            </v-list>
                        </v-menu>
                    </v-toolbar>
                </v-flex>

                <v-container fluid>
                    <v-layout row wrap>

                        <v-flex pa-1 xs12 sm12 md6>
                            <v-layout row wrap>
                                <v-flex xs12 sm1 md1>

                                    <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" v-if="SerbestFatura.Earchiveakayit!= true && SerbestFatura.Efaturakayit!=true && SerbestFatura.KagitFatura!=true " xs12 sm12 md12>
                                        <v-toolbar flat="" size="120px" dark color="green">
                                            <v-toolbar-title> {{$t('Select-Current-Account')}} </v-toolbar-title>
                                        </v-toolbar>
                                    </v-flex>

                                    <v-card flat v-if="SerbestFatura.Earchiveakayit!= true && SerbestFatura.Efaturakayit!=true && SerbestFatura.KagitFatura!=true " v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" color="info" height="100%" class="white--text">
                                        <v-card-actions>
                                            <v-flex xs12 sm12 md12>
                                                <v-layout align-start="" justify-center="" fill height>
                                                    <div class="rotate">
                                                        <div class="icorta">
                                                            <span class="subheading text-no-wrap font-weight-bold white--text mb-2">{{$t('Current')}}</span>
                                                               
                                                        </div>
                                                    </div>
                                                </v-layout>
                                            </v-flex>
                                        </v-card-actions>
                                    </v-card>

                                    <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" v-if="this.SerbestFatura.Earchiveakayit" xs12 sm12 md12>
                                        <v-toolbar flat="" size="120px" dark color="green">
                                            <v-toolbar-title> E-Arşiv </v-toolbar-title>
                                        </v-toolbar>
                                    </v-flex>

                                    <v-card flat v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" v-if="this.SerbestFatura.Earchiveakayit" color="green" height="100%" class="white--text">
                                        <v-card-actions>
                                            <v-flex xs12 sm12 md12>
                                                <v-layout align-start="" justify-center="" fill height>
                                                    <div class="rotate">
                                                        <div class="icorta">
                                                            <span class="subheading text-no-wrap font-weight-bold white--text mb-2">E-Arşiv</span>
                                                        </div>
                                                    </div>
                                                </v-layout>
                                            </v-flex>
                                        </v-card-actions>
                                    </v-card>

                                    <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" v-if="SerbestFatura.Efaturakayit" xs12 sm12 md12>
                                        <v-toolbar flat="" size="120px" dark color="red">
                                            <v-toolbar-title> {{ $t('E-Invoice') }} </v-toolbar-title>
                                        </v-toolbar>
                                    </v-flex>

                                    <v-card flat v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" v-if="SerbestFatura.Efaturakayit" color="red" height="100%" class="white--text">
                                        <v-card-actions>
                                            <v-flex xs12 sm12 md12>
                                                <v-layout align-start="" justify-center="" fill height>
                                                    <div class="rotate">
                                                        <div class="icorta">

                                                            <span class="subheading text-no-wrap font-weight-bold white--text mb-2"> {{ $t('E-Invoice') }} </span>
                                                        </div>
                                                    </div>
                                                </v-layout>
                                            </v-flex>
                                        </v-card-actions>
                                    </v-card>

                                    <v-card flat v-if="this.SerbestFatura.KagitFatura" color="pink" height="100%" class="white--text">
                                        <v-card-actions>
                                            <v-flex xs12 sm12 md12>
                                                <v-layout align-start="" justify-center="" fill height>
                                                    <div class="rotate">
                                                        <div class="icorta">

                                                            <span class="subheading text-no-wrap font-weight-bold white--text mb-2">
                                                              {{ $t('Paper-Invoice') }}</span>
                                                        </div>
                                                    </div>
                                                </v-layout>
                                            </v-flex>
                                        </v-card-actions>
                                    </v-card>
                                    <!-- Yükleme ilerleme -->
<v-dialog v-model="ocrProgressDialog" persistent width="420">
  <v-card class="pa-4">
    <div class="mb-2">Dosya işleniyor…</div>
    <v-progress-linear :indeterminate="ocrBusy" height="6"></v-progress-linear>
  </v-card>
</v-dialog>

<!-- Kontrol uyarısı -->
<v-dialog v-model="ocrNoticeDialog" max-width="520">
  <v-card>
    <v-card-title class="headline pb-0">Fatura yükleme (beta)</v-card-title>
    <v-card-text class="pt-3">
      Fatura yükleme <strong>beta</strong> aşamasındadır. Lütfen bilgileri kontrol ettikten sonra kaydedin.
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="cancelOcrImport">İptal</v-btn>
      <v-btn color="primary" @click="confirmOcrImport">Tamam</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>


                                </v-flex>
                                <v-flex xs11 sm11 md11>

                                    <v-card flat class="white--text">
                                        <v-card flat="">
                                            <v-card-actions>
                                                <v-layout row wrap>
                                                    <v-layout row wrap>
                                                        <v-flex xs10 sm10 md10>
                                                           
                                                                <cariaracomp v-bind:etiket="$t('Accound-Code')" v-bind:value="SerbestFatura.Cari.Kod" :engel="yazdirbtngoster" :loading="loading" 
                                                                   v-model="SerbestFatura.Cari.Kod" v-bind:statecariyedek="statecari"></cariaracomp>
                                                        </v-flex>
                                                        <v-flex xs2 sm2 md2>
                                                            <v-layout align-center="" fill-height="">
                                                                <v-btn fab small @click.native="dialogyenicari=true" color="info" icon>
                                                                    <v-icon>add_box</v-icon>
                                                                </v-btn>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-flex xs12 sm12 md12>
                                                        <span class="body-1 font-weight-bold grey--text mb-2">
                                                            {{$t('Title_label')}}: {{unvan}} </span>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>
                                                        <span class="body-1 font-weight grey--text mb-2">{{$t('Address_label')}} :
                                                            {{ SerbestFatura.EFaturaBilgi.Adres1}} </span>

                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>
                                                        <span class="body-1 font-weight grey--text mb-2">{{$t('IDNumber-or-TaxNumber')}} :
                                                            {{SerbestFatura.EFaturaBilgi.TcKimlikNo}} /
                                                            {{SerbestFatura.EFaturaBilgi.VergiDairesi}}-{{SerbestFatura.EFaturaBilgi.VergiNo}}</span>

                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>
                                                        <span class="body-1 font-weight grey--text mb-2"> {{$t('Credit-Limit')}} :
                                                            {{kredilimiti | moneyformat }}{{getparabirimi()}} </span>

                                                    </v-flex>
                                                </v-layout>
                                            </v-card-actions>
                                        </v-card>
                                    </v-card>
                                </v-flex>
                            </v-layout>

                            <v-flex mt-2 xs12 sm12 md12>
                                <v-card flat class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm6 md6>
                                                    <v-autocomplete :items="faturatipi" clearable hide-details="" v-model="SerbestFatura.FaturaTip" item-text="text" item-value="value" :label="this.$t('Invoice-Type')"></v-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <v-autocomplete hide-details="" :items="EvrakTipi1" v-bind="EvrakTipi1" item-text="Title" v-model="SerbestFatura.Evrak.Evrakkod" clearable item-value="Evrakkod" :label="this.$t('Document-Type')">
                                                    </v-autocomplete>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <referansmerkezicomp :coper="false" v-model="SerbestFatura.Referans.Kod"></referansmerkezicomp>
                                                </v-flex>
                                                <v-flex xs12 sm6 md6>
                                                    <masrafmerkezicomp v-model="SerbestFatura.Masraf.Code"></masrafmerkezicomp>
                                                </v-flex>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-autocomplete :items="doviztipi" clearable hide-details="" item-text="Title" item-value="DovizKod" v-model="SerbestFatura.Doviz.DovizKod" @change="kurgetir('select')" :label="$t('Type-of-currency')"></v-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs12 sm6 md6>
                                                        <dovizinput v-model="SerbestFatura.Kur" :etiket="$t('Exchange-Entry')" ::autocomplete="autocomplete">
                                                        </dovizinput>
                                                    </v-flex>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-text-field v-model="SerbestFatura.Aciklama" maxlength="250" hide-details="" :label="$t('Description')" value="">
                                                        </v-text-field>
                                                    </v-flex>
                                                    <v-checkbox v-model="SerbestFatura.Dovizli" :label="$t('Foreign-Currency-Invoice')" hide-details>
                                                    </v-checkbox>
                                                </v-layout>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>
                        </v-flex>

                        <v-flex pa-1 xs12 sm6 md3>
                            <v-card flat v-if="SerbestFatura.Earchiveakayit==true || SerbestFatura.Efaturakayit==true" class="white--text">
                                <v-card flat="">
                                    <v-card-actions>
                                        <v-layout row wrap>
                                            <v-layout v-if="SerbestFatura.Earchiveakayit" row wrap>
                                                <v-flex xs12 sm12 md12>
                                                    <v-toolbar flat="" size="120px" dark color="green">
                                                        <v-toolbar-title> {{$t('E-archiveinfo_header')}} </v-toolbar-title>
                                                        <v-spacer></v-spacer>
                                                        <v-btn fab @click="earsivbilgigir()" flat>
                                                            <v-icon right dark>edit</v-icon>
                                                        </v-btn>
                                                    </v-toolbar>
                                                </v-flex>

                                                <v-flex xs12 sm12 md12>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm6 md5>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                 {{ $t('Sending-Method') }} :
                                                            </span>
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md7>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{gonderimlabel}}
                                                            </span>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>

                                                <v-flex xs12 sm12 md12>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm6 md5>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                 {{ $t('Internet-Sales') }} :
                                                            </span>
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md7>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{internetsatislabel}}
                                                            </span>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>

                                                <v-flex xs12 sm12 md12>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm6 md5>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{ $t('Web-Address') }} :
                                                            </span>
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md7>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{webadresilabel}}
                                                            </span>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm6 md5>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{ $t('Payment-Method') }} :
                                                            </span>
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md7>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{odemeseklilabel}}
                                                            </span>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>

                                                <v-flex xs12 sm12 md12>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm6 md5>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{$t('Payment-Method-Description')}}: </span>
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md7>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{odemesekliaciklamalabel}}
                                                            </span>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>

                                                <v-flex xs12 sm12 md12>

                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm6 md5>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                Ödeme Aracı: </span>
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md7>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{odemearacilabel}}
                                                            </span>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>

                                                <v-flex xs12 sm12 md12>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm6 md5>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{$t('Payment-Date')}}:</span>
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md7>
                                                            <span class="body-1 font-weight-thin grey--text mb-2">
                                                                {{odemetarihilabel}}
                                                            </span>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout mt-2 v-if="SerbestFatura.Efaturakayit" row wrap>
                                                <v-flex xs12 sm12 md12>
                                                    <v-toolbar flat="" size="120px" dark color="red">
                                                        <v-toolbar-title> E-Fatura Bilgileri </v-toolbar-title>
                                                        <v-spacer></v-spacer>
                                                    </v-toolbar>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <v-select hide-details="" :items="efaturatipi" clearable v-model="efaturatipigecici" item-text="text" :disabled="true" item-value="value" :label="$t('E-invoicetype')"></v-select>
                                                </v-flex>
                                            </v-layout>

                                        </v-layout>
                                    </v-card-actions>
                                </v-card>
                            </v-card>
                        </v-flex>

                        <v-flex pa-1 xs12 sm6 md3>
                            <v-flex xs12 sm12 md12>
                                <v-card flat class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-layout row wrap>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm12 md12>

                                                        <tarihcomp :etiket="$t('Invoice-Date')" :aktifmi="guncellebuton" :detaygizle="true" :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="SerbestFatura.Tarih" v-model="SerbestFatura.Tarih"></tarihcomp>

                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-layout>
                                                            <v-flex xs12 sm6 md6>
                                                                <v-text-field :disabled="seridisable" mask="NNN" :label="$t('Invoice-Serial-No-v3')" :error-messages="errors.collect('faturaseri')" v-validate="'required'" data-vv-name="faturaseri" hide-details="" v-model="SerbestFatura.FaturaSeri" required></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs12 sm6 md6 v-if="gibserigoster == false">
                                                                <v-text-field hide-details="" mask="##################" :disabled="seridisable" :label="$t('Invoice-No')" :error-messages="errors.collect('faturano')" v-model.number="SerbestFatura.FaturaNo" v-validate="'required'" data-vv-name="faturano" required></v-text-field>
                                                            </v-flex>
                                                               <v-flex xs12 sm6 md6 v-if="gibserigoster == true">
                                                                <v-text-field hide-details=""  mask="#########" :disabled="seridisable" :label="$t('Invoice-No')" :error-messages="errors.collect('faturano')" v-model.number="SerbestFatura.FaturaNo" v-validate="'required'" data-vv-name="faturano" required></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>
                                                        <tarihcomp :etiket="$t('Maturity')" :detaygizle="true" :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="SerbestFatura.Vade" v-model="SerbestFatura.Vade"></tarihcomp>

                                                    </v-flex>
                                                    <!-- <v-flex xs12 sm12 md12>
                                                        <v-select :items="Tevkifat" v-model="SerbestFatura.TevkivatKdv" item-text="text" hide-details="" item-value="value" @blur="anatevkifatiptal()" clearable="" label=" Tevkifat KDV" @change="anatevkifatkdvkontrol()"></v-select>
                                                    </v-flex> -->
                                                    <v-flex xs12 sm12 md12>
                                                        <v-select v-if="gibserigoster" :items="gibseri" hide-details="" item-text="Seri" item-value="Seri" clearable v-model="SerbestFatura.GibSeri" :label="this.$t('Gib-Series')">
                                                        </v-select>
                                                    </v-flex>

                                                </v-layout>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>

                            <v-flex xs12 v-if="dizayngoster" sm12 md12>
                                <v-card flat class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-layout row wrap>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-toolbar flat="" size="120px" dark color="#9E9E9E">
                                                            <v-toolbar-title> {{ $t('Design-Selection') }} </v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                        </v-toolbar>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-layout row wrap>

                                                            <v-select :items="dizaynsec" @change="dizaynbilgigetir(SerbestFatura.EFaturaShowID.DizaynID)" v-model="SerbestFatura.EFaturaShowID.DizaynID" hide-details="" clearable item-text="FaturaAciklama" item-value="FaturaId" :label="$t('Select-Design')" :error-messages="errors.collect('dizayn')" v-validate="'required'" data-vv-name="dizayn" required></v-select>

                                                            <!-- <v-select :items="xsltitems" hide-details=""
                                  v-model="SerbestFatura.EFaturaShowID.XsltID" clearable item-text="XsltAciklama"
                                  item-value="FaturaId" :label="$t('Select-xslt-File')"
                                  :error-messages="errors.collect('xslt')" v-validate="'required'" data-vv-name="xslt"
                                  required></v-select> -->

                                                            <reportbrosablon v-show="reportbroview" ref="reportbrosablon" menudisable v-model="SerbestFatura.EFaturaShowID.PdfID" dizayngrupadi="Fatura" objectname="Controllers.ReportBro.Invoice.InvoicePrint">
                                                            </reportbrosablon>

                                                        </v-layout>
                                                    </v-flex>
                                                </v-layout>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>

                        </v-flex>

                    </v-layout>

                    <v-flex mt-2 xs12 sm12 md12>
                        <v-card flat class="white--text">
                            <v-card flat="">
                                <v-card-actions>
                                    <v-layout row wrap>
                                        <v-flex xs12 sm12 md12>

                                            <v-toolbar flat="" size="120px" dark color="#9E9E9E">
                                                <v-toolbar-title>  {{ $t('Line-Entry') }}  </v-toolbar-title>
                                                <v-spacer></v-spacer>
                                                <v-btn @click="satirekle()" flat>{{ $t('Add-Line')}}
                                                    <v-icon color="white" right dark>add_box</v-icon>
                                                </v-btn>
                                            </v-toolbar>
                                        </v-flex>

                                        <v-layout v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" row="" wrap>
                                            <v-flex xs12 sm12 md12>
                                                <v-card flat color="grey lighten-5">
                                                    <v-list>
                                                        <template>
                                                            <v-layout row wrap>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-start justify-start row fill-height>
                                                                        <v-card flat="">
                                                                            <v-list-tile>
                                                                                <v-list-tile-content>
                                                                                    <v-list-tile-sub-title> <span class='grey-text--primary caption '>
                                                                                           {{ $t('EXPLANATION')}}
                                                                                        </span>
                                                                                    </v-list-tile-sub-title>
                                                                                </v-list-tile-content>
                                                                            </v-list-tile>
                                                                        </v-card>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-start justify-end row fill-height>
                                                                        <v-card flat="">
                                                                            <v-list-tile>
                                                                                <v-list-tile-content>
                                                                                    <v-list-tile-sub-title> <span class='grey-text--primary caption '>
                                                                                            {{$t('DISCOUNT')}}
                                                                                        </span>
                                                                                    </v-list-tile-sub-title>
                                                                                </v-list-tile-content>
                                                                            </v-list-tile>
                                                                        </v-card>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-start justify-end row fill-height>
                                                                        <v-card flat="">
                                                                            <v-list-tile>
                                                                                <v-list-tile-content>
                                                                                    <v-list-tile-sub-title> <span class='grey-text--primary caption '>
                                                                                            {{$t('TAXES')}}
                                                                                        </span>
                                                                                    </v-list-tile-sub-title>
                                                                                </v-list-tile-content>
                                                                            </v-list-tile>
                                                                        </v-card>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm1 md1>
                                                                    <v-layout align-start justify-end row fill-height>
                                                                        <v-card flat="">
                                                                            <v-list-tile>
                                                                                <v-list-tile-content>
                                                                                    <v-list-tile-sub-title> <span class='grey-text--primary caption '>
                                                                                            {{$t('VAT')}} %
                                                                                        </span>
                                                                                    </v-list-tile-sub-title>
                                                                                </v-list-tile-content>
                                                                            </v-list-tile>
                                                                        </v-card>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-start justify-end row fill-height>
                                                                        <v-card flat="">
                                                                            <v-list-tile>
                                                                                <v-list-tile-content>
                                                                                    <v-list-tile-sub-title> <span class='grey-text--primary caption '>
                                                                                            {{ $t('VAT') }}
                                                                                        </span>
                                                                                    </v-list-tile-sub-title>
                                                                                </v-list-tile-content>
                                                                            </v-list-tile>
                                                                        </v-card>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-start justify-end row fill-height>
                                                                        <v-card flat="">
                                                                            <v-list-tile>
                                                                                <v-list-tile-content>
                                                                                    <v-list-tile-sub-title> <span class='grey-text--primary caption '>
                                                                                            {{$t('AMOUNT')}}
                                                                                        </span>
                                                                                    </v-list-tile-sub-title>
                                                                                </v-list-tile-content>
                                                                            </v-list-tile>
                                                                        </v-card>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex sm1 md1>
                                                                    <v-layout row align-end justify-start="">
                                                                        <v-card flat="">
                                                                            <v-list-tile>
                                                                                <v-list-tile-content>
                                                                                    <v-list-tile-sub-title> <span class='grey-text--primary caption '>
                                                                                        </span>
                                                                                    </v-list-tile-sub-title>
                                                                                </v-list-tile-content>
                                                                            </v-list-tile>
                                                                        </v-card>
                                                                    </v-layout>
                                                                </v-flex>
                                                            </v-layout>

                                                        </template>

                                                    </v-list>

                                                </v-card>

                                            </v-flex>
                                            <v-flex xs12 sm12 md12>
                                                <v-divider></v-divider>
                                            </v-flex>
                                        </v-layout>

                                        <v-flex xs12 v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" sm12 md12>
                                            <v-layout row="" wrap>
                                                <v-flex xs12 sm12 md12>
                                                    <v-card flat>
                                                        <template v-for="item in satiritems">
                                                            <v-layout v-bind:key="item.id" row wrap>

                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-start justify-start="" row fill-height>
                                                                        <v-card flat="">
                                                                            <v-list-tile-content>
                                                                                <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                                                                        {{item.Aciklama}}
                                                                                    </span>
                                                                                </v-list-tile-sub-title>
                                                                            </v-list-tile-content>
                                                                        </v-card>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-start justify-end="" row fill-height>
                                                                        <v-card flat="">
                                                                            <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                                                                    {{item.IskontoTutar | moneyformat}}{{getparabirimi()}}
                                                                                </span>
                                                                            </v-list-tile-sub-title>
                                                                        </v-card>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-start justify-end="" row fill-height>
                                                                        <v-card flat="">
                                                                            <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                                                                    {{item.TevkifatDetayTutar | moneyformat}}{{getparabirimi()}}
                                                                                </span>
                                                                            </v-list-tile-sub-title>
                                                                        </v-card>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm1 md1>
                                                                    <v-layout align-start justify-end row fill-height>
                                                                        <v-card flat="">
                                                                            <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                                                                    % {{item.KdvYuzde}}
                                                                                </span>
                                                                            </v-list-tile-sub-title>
                                                                        </v-card>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-start justify-end="" row fill-height>
                                                                        <v-card flat="">
                                                                            <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                                                                    {{item.KdvTutar | moneyformat}}{{getparabirimi()}}
                                                                                </span>
                                                                            </v-list-tile-sub-title>
                                                                        </v-card>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-start justify-end row fill-height>
                                                                        <v-card flat="">
                                                                            <v-list-tile-sub-title> &nbsp; <span class='grey-text--primary caption '>
                                                                                    {{item.Tutar | moneyformat}}{{getparabirimi()}}
                                                                                </span>
                                                                            </v-list-tile-sub-title>
                                                                        </v-card>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex sm1 md1>
                                                                    <v-layout row align-center justify-center="">
                                                                        <v-card flat="">
                                                                            <v-layout align-center="" fill-height="" justify-start="">

                                                                                <v-flex sm6 md6>
                                                                                    <v-btn icon>
                                                                                        <v-icon @click="satirduzenle(item)" color="teal">edit</v-icon>
                                                                                    </v-btn>
                                                                                </v-flex>
                                                                                <v-flex sm6 md6>
                                                                                    <v-btn @click="satirsilsor(item)" icon>
                                                                                        <v-icon color="red">delete</v-icon>
                                                                                    </v-btn>
                                                                                </v-flex>
                                                                            </v-layout>
                                                                        </v-card>
                                                                    </v-layout>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-divider :key="item.id"></v-divider>
                                                        </template>

                                                    </v-card>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>

                                        <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" xs12 sm12 md12>
                                            <v-card class="grey--text">
                                                <template v-for="item in satiritems">
                                                    <v-layout pa-1 v-bind:key="item.id" row wrap>
                                                        <v-layout row wrap>
                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-start="" fill-height="">
                                                                    <span class="subheading font-weight-">
                                                                        {{$t('Description')}}:
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>
                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-end="" fill-height="">
                                                                    <span class="subheading font-weight-thin">
                                                                        {{item.Aciklama}}
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>

                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-start="" fill-height="">
                                                                    <span class="subheading font-weight-">
                                                                        {{$t('Discount')}}
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>
                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-end="" fill-height="">
                                                                    <span class="subheading font-weight-thin">
                                                                        {{item.IskontoTutar | moneyformat}}{{getparabirimi()}}
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>

                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-start="" fill-height="">
                                                                    <span class="subheading font-weight-">
                                                                         {{ $t('Withholding-VAT') }} :
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>
                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-end="" fill-height="">
                                                                    <span class="subheading font-weight-thin">
                                                                        {{item.TevkifatDetayTutar | moneyformat}}{{getparabirimi()}}
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>

                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-start="" fill-height="">
                                                                    <span class="subheading font-weight-">
                                                                        Kdv %:
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>
                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-end="" fill-height="">
                                                                    <span class="subheading font-weight-thin">
                                                                        {{item.KdvYuzde }}
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>

                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-start="" fill-height="">
                                                                    <span class="subheading font-weight-">
                                                                         {{ $t('VAT-Amount') }} :
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>
                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-end="" fill-height="">
                                                                    <span class="subheading font-weight-thin">
                                                                        {{item.KdvTutar | moneyformat}}{{getparabirimi()}}
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>
                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-start="" fill-height="">
                                                                    <span class="subheading font-weight-">
                                                                       {{ $t('Amount')}} :
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>
                                                            <v-flex xs6 sm6 md6>
                                                                <v-layout align-center="" justify-end="" fill-height="">
                                                                    <span class="subheading font-weight-thin">
                                                                        {{item.Tutar | moneyformat}}{{getparabirimi()}}
                                                                    </span>
                                                                </v-layout>
                                                            </v-flex>
                                                            <v-flex xs12 sm12 md12>
                                                                <v-divider light></v-divider>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-layout>
                                                </template>
                                            </v-card>
                                        </v-flex>

                                    </v-layout>

                                </v-card-actions>
                            </v-card>
                        </v-card>
                    </v-flex>
                </v-container>

                <v-container fluid>
                    <v-layout>
                        <v-flex xs12 sm12 md12>
                            <v-layout justify-end="" row>
                                <v-flex xs12 sm12 md4>
                                    <v-card flat class="white--text">
                                        <v-layout>
                                            <v-flex xs2 sm2 md2>
                                                <v-layout align-center="" justify-center="" fill-height="">
                                                    <v-icon color="info" large="">queue</v-icon>
                                                </v-layout>
                                            </v-flex>
                                            <v-flex xs12 sm10 md8>

                                                <v-card-title primary-title="">
                                                    <v-flex xs12 sm12 md12>
                                                        <v-layout>
                                                            <v-flex xs12 sm4 md4>
                                                                <v-list-tile-title>
                                                                    <span class="subheading grey--text font-weight-thin">
                                                                        {{ $t('Amount')}} :
                                                                    </span>
                                                                </v-list-tile-title>
                                                            </v-flex>
                                                            <v-flex xs12 sm8 md8>
                                                                <v-list-tile-title>
                                                                    <span class="subheading grey--text font-weight-">
                                                                        : {{SerbestFatura.Tutarlar.ToplamTutar | moneyformat}}{{getparabirimi()}}

                                                                    </span>

                                                                </v-list-tile-title>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-layout>
                                                            <v-flex xs12 sm4 md4>
                                                                <v-list-tile-title>
                                                                    <span class="subheading grey--text font-weight-thin">
                                                                        {{ $t('DISCOUNT')}} :
                                                                    </span>
                                                                </v-list-tile-title>
                                                            </v-flex>
                                                            <v-flex xs12 sm8 md8>
                                                                <v-list-tile-title>
                                                                    <span class="subheading grey--text font-weight-">
                                                                        : {{SerbestFatura.Tutarlar.Iskonto | moneyformat}}{{getparabirimi()}} </span>
                                                                </v-list-tile-title>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>
                                                        <v-layout v-if="PB=='TRY'">
                                                            <v-flex xs12 sm4 md4>
                                                                <v-list-tile-title>
                                                                    <span class="subheading grey--text font-weight-thin">
                                                                     {{$t('Withholding-Amount')}}
                                                                    </span>
                                                                </v-list-tile-title>
                                                            </v-flex>
                                                            <v-flex xs12 sm8 md8>
                                                                <v-list-tile-title>
                                                                    <span class="subheading grey--text font-weight-">
                                                                        : {{SerbestFatura.Tutarlar.TevkifatKdv | moneyformat}}{{getparabirimi()}} </span>
                                                                </v-list-tile-title>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                </v-card-title>
                                            </v-flex>
                                        </v-layout>
                                        <v-divider light></v-divider>
                                        <v-card-actions class="pa-3"> <span class="subheading grey--text font-weight-">
                                                {{ $t('Grand-Total') }}</span><span class="subheading grey--text font-weight-">
                                                : {{SerbestFatura.Tutarlar.FaturaToplam | moneyformat}}{{getparabirimi()}}
                                                ({{SerbestFatura.Tutarlar.Kdv | moneyformat}}{{getparabirimi()}} KDV)</span>
                                            <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>

                </v-container>

            </v-layout>
        </v-card>
    </v-form>

    <v-dialog v-model="faturadialog" scrollable="" max-width="850px">
        <v-card>
            <v-card-title> {{ $t('E-Invoice') }} </v-card-title>
            <v-divider></v-divider>
            <v-card-text>

                <v-layout row wrap="">

                    <div class="flex md12">
                        <span id="demo2">
                        </span>
                    </div>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="satirdialog" scrollable="" persistent="" max-width="800px">
        <v-card color="grey lighten-5">
            <v-card-title> {{ $t('Line-Entry') }} </v-card-title>
            <v-divider></v-divider>
            <v-card-text>

                <v-layout row wrap="">

                    <v-flex pa-1 xs12 sm6 md6>
                        <v-card class="white--text">
                            <v-card flat="">
                                <v-card-actions>

                                    <v-layout justify-space-between column>
                                       
                                        <muhasebekoducomp :etiket="$t('Accounting-Code')" v-model="SerbestFaturaDetay.MuhasebeKodu">
                                        </muhasebekoducomp>

                                        <v-text-field hide-details="" v-model="SerbestFaturaDetay.Aciklama" maxlength="499" aria-multiline="" :label="$t('Description')"></v-text-field>

                                        <v-text-field v-model="SerbestFaturaDetay.LineNote" hide-details="" aria-multiline="" label="Line Note"></v-text-field>
                                        <referansmerkezicomp :coper="false" v-model="SerbestFaturaDetay.Referans.Kod"></referansmerkezicomp>

                                        <masrafmerkezicomp v-model="SerbestFaturaDetay.Masraf.Code"></masrafmerkezicomp>

                                        <v-text-field type="number" hide-details="" v-model="SerbestFaturaDetay.Miktar" :label="$t('Unit-Quantity')">
                                        </v-text-field>

                                        <v-select v-model="SerbestFaturaDetay.Birim" hide-details="" :label="$t('Unit')" item-text="text" item-value="value" :items="birim" persistent-hint></v-select>

                                        <parainput :simge="getdefaultparabirimi(SerbestFatura.Doviz.DovizKod)" v-model="SerbestFaturaDetay.BirimFiyat" :etiket="$t('Unit-Price')" @input="dovizlitutarhesapla()" :autocomplete="autocomplete">
                                        </parainput>

                                        <parainput :simge="getparabirimi()" v-model="SerbestFaturaDetay.Tutar" :etiket="this.$t('Amount')" @input="YuzdeKontrol()" :autocomplete="autocomplete">
                                        </parainput>

                                        <parainput @odakkaybi="satirDovizOdakKaybi" :simge="getdefaultparabirimi(SerbestFatura.Doviz.DovizKod)" v-model="SerbestFaturaDetay.DovizTutar" :etiket="$t('Currency-Amount')" :autocomplete="autocomplete">
                                        </parainput>
                                    </v-layout>

                                </v-card-actions>
                            </v-card>
                        </v-card>
                    </v-flex>

                    <v-flex pa-1 xs12 sm6 md6>
                        <v-card class="white--text">
                            <v-card flat="">
                                <v-card-actions>
                                    <v-layout justify-space-between column>
                                        <v-select hide-details="" :items="kdvtipi" :label="$t('VAT-Type')" v-model="SerbestFaturaDetay.KdvTip" item-text="text" clearable item-value="value"></v-select>
                                        <v-layout>
                                            <yuzdeinput :etiket="$t('Discount-Percentage')" v-model="SerbestFaturaDetay.IskontoYuzde"></yuzdeinput>

                                            <parainput :simge="getparabirimi()" v-model="SerbestFaturaDetay.IskontoTutar" :etiket="$t('Discount-Amount')" :autocomplete="autocomplete"></parainput>

                                        </v-layout>
                                        <v-layout>
                                            <yuzdeinput v-model="SerbestFaturaDetay.KdvYuzde" :etiket="$t('VAT-Percentage')"></yuzdeinput>
                                            <parainput :simge="getparabirimi()" v-model="SerbestFaturaDetay.KdvTutar" :etiket="$t('VAT-Amount')" :aktif="kdvShow" :autocomplete="autocomplete"></parainput>
                                        </v-layout>

                                        <muhasebekoducomp :etiket="$t('VAT-Accounting-Code')" v-model="SerbestFaturaDetay.KdvMuhKodu">
                                        </muhasebekoducomp>

                                        <muhasebekoducomp :etiket="$t('Discount-Accounting-Code')" v-model="SerbestFaturaDetay.IskMuhKodu">
                                        </muhasebekoducomp>

                                        <geneltiplist v-model="SerbestFaturaDetay.KdvKodu" :etiket="$t('VAT-Code')" :listetip="'303'">
                                        </geneltiplist>

                                        <geneltiplist v-model="SerbestFaturaDetay.IstisnaKodu" :etiket="$t('Exception-Code')" :listetip="'304'">
                                        </geneltiplist>

                                        <v-select :items="Tevkifat" v-if="detaytevkifat && PB=='TRY'" hide-details="" item-text="text" item-value="value" clearable v-model="SerbestFaturaDetay.TevkifatDetayOran" @change="Tevkifatkdvhesapla()" label=" Tevkifat KDV Oranı"></v-select>

                                        <parainput :simge="getparabirimi()" :aktif="'false'" v-if="detaytevkifat && PB=='TRY'" v-model="SerbestFaturaDetay.TevkifatDetayTutar" :etiket="'Tev. KDV Tutar'" :autocomplete="autocomplete"></parainput>

                                        <geneltiplist v-if="PB=='TRY'" v-model="SerbestFaturaDetay.TevkifatKodu" :etiket="$t('Withholding-Code')" :listetip="'302'">
                                        </geneltiplist>

                                    </v-layout>
                                </v-card-actions>
                            </v-card>
                        </v-card>
                    </v-flex>

                    <v-flex xs12 v-if="ihracat" pa-1 sm12 md12>

                        <v-toolbar flat="" size="120px" dark color="#9E9E9E">
                            <v-toolbar-title> {{ $t('Importation-Details') }} </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                    </v-flex>

                    <v-flex pa-1 v-if="ihracat" xs12 sm6 md6>
                        <v-card class="white--text">
                            <v-card flat="">
                                <v-card-actions>
                                    <v-layout justify-space-between column>

                                        <v-text-field v-model="SerbestFaturaDetay.TeslimBilgileri.SokakAdi" hide-details="" :label="$t('Delivery-Street')"></v-text-field>

                                        <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.BinaAdi" :label="$t('Delivery-Building')"></v-text-field>

                                        <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.BinaNo" :label="$t('Delivery-Building-No')"></v-text-field>

                                        <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.TeslimSehir" :label="$t('Delivery-Province')"></v-text-field>

                                        <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.TeslimPostaKodu" :label="$t('Delivery-Postal-Code')"></v-text-field>

                                        <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.TeslimUlke" :label="$t('Delivery-Country')"></v-text-field>

                                        <v-select :label="$t('Delivery-Payment')" clearable="" v-model="SerbestFaturaDetay.TeslimBilgileri.TeslimOdeme" :items="teslimodeme"></v-select>

                                    </v-layout>
                                </v-card-actions>
                            </v-card>
                        </v-card>
                    </v-flex>

                    <v-flex pa-1 v-if="ihracat" xs12 sm6 md6>
                        <v-card class="white--text">
                            <v-card flat="">
                                <v-card-actions>
                                    <v-layout justify-space-between column>

                                        <v-text-field v-model="SerbestFaturaDetay.TeslimBilgileri.TeslimSarti" hide-details="" :label="$t('Delivery-Condition')"></v-text-field>

                                        <v-text-field hide-details="" :error-messages="errors.collect('gtip')" v-validate="'min:4'" data-vv-name="gtip" v-model="SerbestFaturaDetay.TeslimBilgileri.GTIPNo" label="GTIP No">
                                        </v-text-field>

                                        <v-select :items="transferkodu" hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.TransferKodu" :label="$t('Transfer-Code')" item-text="text" item-value="value" max-height="400"></v-select>

                                        <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.KabinNo" :label="$t('Cabin-No')"></v-text-field>

                                        <v-text-field type="number" v-model="SerbestFaturaDetay.TeslimBilgileri.KabinAdedi" hide-details="" :label="$t('Number-of-Cabins')"></v-text-field>

                                        <v-text-field hide-details="" v-model="SerbestFaturaDetay.TeslimBilgileri.KabinCinsi" :label="$t('Cabin-Type')"></v-text-field>

                                    </v-layout>
                                </v-card-actions>
                            </v-card>
                        </v-card>
                    </v-flex>
                </v-layout>

            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="satirDialogIptal()">{{$t("cancel_button")}}</v-btn>

                <v-btn v-if="satirkaydetbuton" :disabled="calculateDisabled" color="blue darken-1" flat @click.native="satirkaydet()">{{$t('Add-Line')}}</v-btn>

                <v-btn v-if="satirguncellebuton" :disabled="calculateDisabled" color="blue darken-1" flat @click.native="satirguncellekaydet()">{{ $t('Update') }}
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="iadedialog" scrollable="" persistent="" max-width="350px">
        <v-card flat color="grey lighten-5">
            <v-card-title> {{ $t('Required-Fields-for-Return-Invoice') }} </v-card-title>
            <v-divider></v-divider>
            <v-card-text>

                <v-layout row wrap="">

                    <v-flex xs12 sm12 md12>
                        <v-form ref="formiade" v-model="iadevalid" lazy-validation>
                            <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                    <tarihcomp :etiket="$t('Invoice-Date-Referring-To')" :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:value="SerbestFatura.IadeFaturaBilgi.IstinadenFaturaTarihi" v-model="SerbestFatura.IadeFaturaBilgi.IstinadenFaturaTarihi"></tarihcomp>
                                </v-flex>
                                <v-flex xs12 sm6 md6>
                                    <v-text-field hide-details="" :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="SerbestFatura.IadeFaturaBilgi.IstinadenFaturaSeri" label="Seri">
                                    </v-text-field>

                                </v-flex>

                                <v-flex xs12 sm6 md6>
                                    <v-text-field hide-details="" :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="SerbestFatura.IadeFaturaBilgi.IstinadenFaturaNo"  label="No">
                                    </v-text-field>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                    <v-text-field hide-details="" :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="SerbestFatura.IadeFaturaBilgi.IadeNedeni" maxlength="99" :label="$t('Cause')">
                                    </v-text-field>

                                </v-flex>

                            </v-layout>
                        </v-form>
                    </v-flex>

                </v-layout>

            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="iadedialog=false">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" v-if="guncellebuton" flat @click.native="iadeFaturaKayit()">{{ $t('Update') }}</v-btn>
                <v-btn color="blue darken-1" v-if="kaydetbuton" flat @click.native="iadeFaturaKayit()">{{$t("save_button")}}</v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialogdegistir" scrollable="" persistent="" max-width="400px">
        <v-card color="grey lighten-5">
            <v-card-title> {{ $t('Change-Invoice-Details') }} </v-card-title>
            <v-divider></v-divider>
            <v-card-text>

                <v-flex ma-1 xs12 sm12 md12>
                    <v-card class="white--text">
                        <v-card flat="">
                            <v-card-actions>

                                <v-flex xs12 sm12 md12>
                                    <div v-if="islemturu==1">
                                        <tarihcomp :etiket="$t('Date')" v-bind:value="ChangeTarih" v-model="ChangeTarih"></tarihcomp>
                                    </div>
                                    <div v-if="islemturu==0">
                                        <v-layout>
                                            <v-flex xs12 sm12 md12>
                                                <v-text-field hide-details="" type="number" :label="$t('Invoice-Number-v2')" v-model="ChangeFaturaNo">
                                                </v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </div>
                                </v-flex>
                            </v-card-actions>
                        </v-card>
                    </v-card>
                </v-flex>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="dialogdegistir=false">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click="faturabilgidegistir()">Değiştir</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialogearsiv" scrollable="" persistent="" max-width="400px">
        <v-card color="grey lighten-5">
            <v-card-title> {{ $t('E-Archive-Information-Entry') }} </v-card-title>
            <v-divider></v-divider>
            <v-card-text>

                <v-flex xs12 sm12 md12 style=" padding-bottom:10px;">
                    <v-card class="white--text">
                        <v-card flat="">
                            <v-card-actions>

                                <v-layout row="" wrap="">
                                    <div class="flex md12">

                                        <v-select :items="gonderimsekli" hide-details="" v-model="SerbestFatura.EarsivBilgi.GonderimSekli" :label="$t('Sending-Method')" item-text="text" item-value="value" max-height="400"></v-select>

                                        <v-select v-model="SerbestFatura.EarsivBilgi.InternetSatis" hide-details="" :items="odemesekli" :label="$t('Internet-Sales')" item-text="text" item-value="value" max-height="400" persistent-hint>
                                        </v-select>

                                        <v-select :items="webadresleri" hide-details="" v-model="SerbestFatura.EarsivBilgi.WebAdresi" :label="$t('Web-Address')" item-text="Aciklama" clearable item-value="ID" max-height="400"></v-select>

                                        <v-select :items="odemesekli1" hide-details="" v-model="SerbestFatura.EarsivBilgi.OdemeSekli" :label="$t('Payment-Method')" item-text="text" clearable item-value="value" max-height="400"></v-select>

                                        <v-select :items="odemesekilleri" hide-details="" v-model="SerbestFatura.EarsivBilgi.OdemeSekliAciklama" :label="$t('Payment-Method-Description')" item-text="Aciklama" clearable item-value="ID" max-height="400"></v-select>

                                        <v-select :items="odemearaci" hide-details="" v-model="SerbestFatura.EarsivBilgi.OdemeAraci" label="Ödeme Aracı" item-text="Aciklama" clearable item-value="ID" max-height="400" persistent-hint></v-select>

                                        <tarihcomp :etiket="$t('Payment-Date')" hide-details="" :tabindex="'17'" v-bind:value="SerbestFatura.EarsivBilgi.OdemeTarihi" v-model="SerbestFatura.EarsivBilgi.OdemeTarihi"></tarihcomp>

                                    </div>
                                </v-layout>
                            </v-card-actions>
                        </v-card>
                    </v-card>
                </v-flex>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="dialogearsiv=false">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="dialogearsiv=false">{{$t("save_button")}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialogyenicari" scrollable="" persistent="" max-width="400px">
        <v-card color="grey lighten-2">
            <v-card-title> {{ $t('Add-New-Current-Card') }} </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-layout row="" wrap="">
                    <v-flex pa-1 xs12 sm6 md12>
                        <v-card class="white--text">
                            <v-card color="grey lighten-4" flat="">
                                <v-card-actions>
                                    <v-layout justify-space-between column>
                                        <v-form ref="formcariyegore" v-model="valid" lazy-validation>

                                            <v-select :items="musteritipi" hide-details="" v-model="Current.CustomerType" item-text="text" item-value="value" clearable :label="$t('Customertype_label')">
                                            </v-select>
                                            <v-text-field :rules="[v => !!v || $t('This-area-mandatory')]" :label="$t('Currentcode_label')" maxlength="15" v-model="Current.Code" hide-details="">
                                            </v-text-field>
                                            <v-text-field hide-details="" :rules="[v => !!v || $t('This-area-mandatory')]" :label="$t('Title_label')" maxlength="100" v-model="Current.Title">
                                            </v-text-field>
                                            <v-text-field hide-details="" maxlength="15" :label="$t('Phonenumber_label')" v-model="Current.Phone1"></v-text-field>
                                            <v-text-field hide-details="" :label="$t('Email_label')" v-model="Current.Email"></v-text-field>
                                            <v-text-field hide-details="" :label="$t('Accounting-Code')" maxlength="25" v-model="Current.AccountingCode">
                                            </v-text-field>

                                        </v-form>

                                    </v-layout>
                                </v-card-actions>
                            </v-card>
                        </v-card>
                    </v-flex>

                    <v-flex pa-1 xs12 sm6 md12>
                        <v-card class="white--text">
                            <v-card color="grey lighten-4" flat="">
                                <v-card-actions>
                                    <v-layout justify-space-between column>
                                        <v-card flat="" color="#9E9E9E">
                                            <v-card-title>
                                                <span class="subheading white--text font-weight-medium ">Fatura Adres
                                                    Bilgileri</span>
                                            </v-card-title>
                                        </v-card>
                                        <v-text-field hide-details="" :label="$t('Taxcenter_label')" v-model="Current.Invoice.TaxOffice">
                                        </v-text-field>
                                        <v-text-field hide-details="" :label="$t('Taxnumber_label')" v-model="Current.Invoice.TaxNumber">
                                        </v-text-field>
                                        <v-text-field hide-details="" :label="$t('Postcode_label')" v-model="Current.Invoice.PostCode">
                                        </v-text-field>
                                        <v-text-field hide-details="" :label="$t('Country_label')" v-model="Current.Invoice.Country"></v-text-field>
                                        <v-text-field hide-details="" :label="$t('Province_label')" v-model="Current.Invoice.Province"></v-text-field>
                                        <v-textarea hide-details="" no-resize v-model="Current.Invoice.Address" :label="$t('Address_label')">
                                        </v-textarea>
                                    </v-layout>
                                </v-card-actions>
                            </v-card>
                        </v-card>

                    </v-flex>

                    <v-flex pa-1 xs12 sm12 md12>
                        <v-card class="white--text">
                            <v-card color="grey lighten-4" flat="">
                                <v-card-actions>
                                    <v-layout justify-space-between column>

                                        <v-card flat="" color="#9E9E9E">
                                            <v-card-title>
                                                <span class="subheading white--text font-weight-medium "> T.C. Kimlik ile
                                                    işlem gören için</span>
                                            </v-card-title>
                                        </v-card>

                                        <v-text-field hide-details="" :label="$t('Identitynumber_label')" value="" mask="###########" v-model="Current.Invoice.IdentityNumber"></v-text-field>
                                        <v-text-field hide-details="" :label="$t('Name_label')" maxlength="50" v-model="Current.Invoice.PerFirstName" required>
                                        </v-text-field>
                                        <v-text-field hide-details="" :label="$t('Surname_label')" maxlength="50" v-model="Current.Invoice.PerFamilyName" required>
                                        </v-text-field>
                                        <v-text-field hide-details="" :label="$t('Title_label')" maxlength="50" v-model="Current.Invoice.PerTitle" required>
                                        </v-text-field>
                                        <v-text-field hide-details="" :label="$t('Othername_label')" maxlength="50" v-model="Current.Invoice.PerMiddleName" required>
                                        </v-text-field>
                                        <v-text-field hide-details="" :label="$t('Suffixname_label')" maxlength="50" v-model="Current.Invoice.PerNameSuffix" required>
                                        </v-text-field>
                                    </v-layout>
                                </v-card-actions>
                            </v-card>
                        </v-card>
                    </v-flex>

                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="dialogyenicari=false">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="yenicarikaydet()">{{$t("save_button")}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="loadingdialog" hide-overlay persistent width="300">
        <v-card color="primary" dark>
            <v-card-text>
                {{ $t('Your-invoice-information-being-prepared') }} , ...
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialogsor" persistent max-width="290">
        <v-card>
            <v-card-title class="headline">{{ $t('Warning') }} !</v-card-title>
            <v-card-text>Bu kayıtı silmek istediğinize emin misiniz?</v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="info" flat @click.native="dialogsor=false">{{$t("cancel_button")}}</v-btn>
                <v-btn v-if="faturasilbtn" color="info" flat @click="faturasil()">{{ $t('OK') }}</v-btn>

                <v-btn v-if="satirsilbtn" color="info" flat @click="satirsil()">{{ $t('OK') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>


</div>
</template>

<script>
import auth from '../../../api/auth'
import parainput from '../customcomp/parainput'
import dovizinput from '../customcomp/dovizinput'
import yuzdeinput from '../customcomp/yuzdeinput'
import tarihcomp from '../customcomp/tarihim'
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
import reportbrosablon from "@/components/app/coper/comp/reportbrosablon.vue";
import geneltiplist from "@/components/app/customcomp/geneltiplist.vue"
import helpers from "@/components/app/customcomp/helpers.js"
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
import onaydialog from "@/components/app/customcomp/onaydialog.vue"
import muhasebekoducomp from '@/components/app/customcomp/muhasebekoducomp.vue'
import cariaracomp from '@/components/app/customcomp/cariaracomp'
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";

// ---------- Helpers ----------
function ocrFirstNonEmpty() {
  for (var i = 0; i < arguments.length; i++) {
    var v = arguments[i];
    if (v !== undefined && v !== null && String(v).trim() !== '') return v;
  }
  return null;
}
function ocrParseDecimal(v) {
  if (v === undefined || v === null) return 0;
  var s = String(v).trim();
  var useCommaAsDecimal = s.lastIndexOf(',') > s.lastIndexOf('.');
  var n = useCommaAsDecimal ? s.replace(/\./g, '').replace(',', '.') : s.replace(/,/g, '');
  var d = parseFloat(n);
  return isNaN(d) ? 0 : d;
}
function ocrMoneyOrNull(v) {
  if (v === undefined || v === null) return null;
  var d = ocrParseDecimal(v);
  return isNaN(d) ? null : +d.toFixed(2);
}
function ocrTo2(v) { return +ocrParseDecimal(v).toFixed(2); }

function ocrParseDateToIso(s) {
  if (!s) return null;
  s = String(s).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  var m = s.match(/(\d{1,4})[\.\/\-](\d{1,2})[\.\/\-](\d{1,4})/);
  if (m) {
    var a = [m[1], m[2], m[3]], y, M, d;
    if (a[0].length === 4) { y = +a[0]; M = +a[1]; d = +a[2]; }
    else if (a[2].length === 4) { d = +a[0]; M = +a[1]; y = +a[2]; }
    else { d = +a[0]; M = +a[1]; y = 2000 + (+a[2]); }
    var mm = (M < 10 ? '0'+M : ''+M);
    var dd = (d < 10 ? '0'+d : ''+d);
    return y + '-' + mm + '-' + dd;
  }
  var d2 = new Date(s);
  if (isNaN(d2.getTime())) return null;
  var mm2=('0'+(d2.getMonth()+1)).slice(-2), dd2=('0'+d2.getDate()).slice(-2);
  return d2.getFullYear() + '-' + mm2 + '-' + dd2;
}

// yalnız KDV yüzdesi için: 20.00 -> 20
function ocrPercentInt(v) {
  var d = ocrParseDecimal(v);
  return isNaN(d) ? 0 : Math.trunc(d);
}

// açıklamadan % yakala (yedek)
function ocrTryExtractVatPercent(desc) {
  if (!desc) return null;
  var m = String(desc).match(/(?:%?\s*)(?:vat|tva|kdv|moms)?\s*[:%]?\s*(\d{1,2}(?:[.,]\d{1,2})?)\s*%?/i);
  return m ? ocrParseDecimal(m[1]) : null;
}

// istersen açıklamayı sadeleştirmek için kullan
function ocrTextOnly(desc) {
  if (!desc) return '';
  desc = desc.replace(/(\d{1,3}(?:\.\d{3})*(?:,\d{2})|\d{1,3}(?:,\d{3})*(?:\.\d{2})|\d+(?:[.,]\d{2}))/g, ' ');
  desc = desc.replace(/(\d{1,2}(?:[.,]\d{1,2})?)\s*%/g, ' ');
  desc = desc.replace(/\b((?:[0-3]?\d[\/\.-][01]?\d[\/\.-](?:20)?\d{2})|(?:\d{4}[\/\.-][01]?\d[\/\.-][0-3]?\d)|(?:\d{2}-[A-Z]{3}-\d{4}))\b/gi, ' ');
  desc = desc.replace(/(?<!\w)(\d{1,4})(?!\w)/g, ' ');
  return desc.replace(/\s{2,}/g,' ').trim().replace(/^[:;\-|\s]+|[:;\-|\s]+$/g,'');
}

// ---------- Mapper ----------
function mapOcrToSerbestFatura(ocr, mevcutModel) {
  var f = JSON.parse(JSON.stringify(mevcutModel || {}));
  var fld = (ocr && ocr.fields) || {};
  var cur = ((fld.currency || '') + '').toUpperCase();

  // Üst alanlar
  f.FaturaSeri = f.FaturaSeri || (fld.serial_number || '');
  f.FaturaNo   = ocrFirstNonEmpty(fld.document_number, f.FaturaNo) || '';

  var issueIso = ocrParseDateToIso(fld.issue_date);
  var dueIso   = ocrParseDateToIso(fld.due_date);
  f.Tarih = issueIso || f.Tarih || null;
  f.Vade  = dueIso   || f.Tarih || null;

  f.Referans = f.Referans || { Kod: '' };
  f.Referans.Kod = ocrFirstNonEmpty(fld.reference_code, f.Referans.Kod) || '';

  f.Doviz = f.Doviz || { DovizKod: '' };
  f.Doviz.DovizKod = cur || (f.Doviz.DovizKod || 'TRY');
  f.Dovizli = cur && cur !== 'TRY' ? true : false;
  f.Kur = ocrTo2(ocrFirstNonEmpty(fld.exchange_rate, f.Kur));

  f.Aciklama = ocrFirstNonEmpty(fld.notes, f.Aciklama) || '';

  // Özetler (varsa)
  f.Tutarlar = f.Tutarlar || { ToplamTutar: 0, Iskonto: 0, FaturaToplam: 0, Kdv: 0, TevkifatKdv: 0 };
  var subtotal = ocrMoneyOrNull(fld.subtotal);
  var grand    = ocrMoneyOrNull(fld.grand_total);
  var taxtotal = ocrMoneyOrNull(fld.tax_total);
  if (subtotal != null) f.Tutarlar.ToplamTutar = subtotal;
  if (grand    != null) f.Tutarlar.FaturaToplam = grand;
  if (taxtotal != null) f.Tutarlar.Kdv         = taxtotal;

  // Satırlar
  f.SerbestFaturaDetay = [];
  var lines = Array.isArray(ocr && ocr.lines) ? ocr.lines : [];

  for (var i = 0; i < lines.length; i++) {
    var ln = lines[i] || {};
    var desc = (ln.description || '').trim();
    if (!desc) continue;

    // Tutar (öncelik: unit -> net -> line_total/(1+%kdv))
    var amountFromUnit = ocrParseDecimal(ln.unit);
    var netFromJson    = ocrParseDecimal(ln.net);
    var totFromJson    = ocrParseDecimal(ln.line_total);

    var kdvPctCandidate = (ln.tax_rate != null) ? ocrParseDecimal(ln.tax_rate) : ocrTryExtractVatPercent(desc);
    var kdvYuzde = ocrPercentInt(kdvPctCandidate); // 20.00 -> 20

    var net = 0;
    if (amountFromUnit)       net = amountFromUnit;
    else if (netFromJson)     net = netFromJson;
    else if (totFromJson && kdvYuzde) net = +(totFromJson / (1 + (kdvYuzde / 100))).toFixed(2);

    // KDV Tutar = Tutar × (KDV%/100)
    var kdvTutar = (kdvYuzde > 0 && net > 0) ? +(net * (kdvYuzde / 100)).toFixed(2) : 0;

    f.SerbestFaturaDetay.push({
      MuhasebeKodu: '',
      Aciklama: desc,
      LineNote: '',
      Referans: { Kod: (f.Referans && f.Referans.Kod) || '' },
      Masraf:   { Code: (f.Masraf && f.Masraf.Code) || '' },

      Miktar: 1,
      Birim:  '',
      BirimFiyat: 0,

      // MAL HİZMET TUTARI (unit’ten)
      Tutar: ocrTo2(net),
      DovizTutar: (f.Dovizli && f.Kur > 0) ? ocrTo2(net / f.Kur) : ocrTo2(net),

      IskontoYuzde: 0,
      IskontoTutar: 0,

      // KDV (yüzde ve tutar doldurulsun)
      KdvTip: 'D',                 // burada biz hesaplayıp yazıyoruz
      KdvYuzde: kdvYuzde,          // tam sayı (ör: 20)
      KdvTutar: ocrTo2(kdvTutar),  // net * %kdv

      KdvMuhKodu: '', IskMuhKodu: '', KdvKodu: '',
      IstisnaKodu: '', TevkifatKodu: '', Tip: '',
      TevkifatDetayTutar: 0, TevkifatDetayOran: 0,
      TeslimBilgileri: {
        SokakAdi:'',BinaAdi:'',BinaNo:'',TeslimSehir:'',TeslimPostaKodu:'',
        TeslimUlke:'',TeslimSarti:'',GTIPNo:'',TransferKodu:'',
        KabinNo:'',KabinAdedi:'',KabinCinsi:'',TeslimOdeme:''
      }
    });
  }

  // hiç satır yoksa emniyet satırı
  if (f.SerbestFaturaDetay.length === 0) {
    f.SerbestFaturaDetay.push({
      MuhasebeKodu:'', Aciklama:f.Aciklama || '', LineNote:'',
      Referans:{Kod: (f.Referans && f.Referans.Kod) || ''},
      Masraf:{Code: (f.Masraf && f.Masraf.Code) || ''},
      Miktar:1, Birim:'', BirimFiyat:0,
      Tutar:0, DovizTutar:0,
      IskontoYuzde:0, IskontoTutar:0,
      KdvTip:'D', KdvYuzde:0, KdvTutar:0,
      KdvMuhKodu:'', IskMuhKodu:'', KdvKodu:'',
      IstisnaKodu:'', TevkifatKodu:'', Tip:'',
      TevkifatDetayTutar:0, TevkifatDetayOran:0,
      TeslimBilgileri:{
        SokakAdi:'',BinaAdi:'',BinaNo:'',TeslimSehir:'',TeslimPostaKodu:'',
        TeslimUlke:'',TeslimSarti:'',GTIPNo:'',TransferKodu:'',
        KabinNo:'',KabinAdedi:'',KabinCinsi:'',TeslimOdeme:''
      }
    });
  }

  // özetleri boşsa görünüm için Net topla
  var sumNet = 0, sumTax = 0;
  for (var j = 0; j < f.SerbestFaturaDetay.length; j++) {
    sumNet += ocrParseDecimal(f.SerbestFaturaDetay[j].Tutar);
    sumTax += ocrParseDecimal(f.SerbestFaturaDetay[j].KdvTutar);
  }
  if (!f.Tutarlar.ToplamTutar)  f.Tutarlar.ToplamTutar = +sumNet.toFixed(2);
  if (!f.Tutarlar.Kdv)          f.Tutarlar.Kdv         = +sumTax.toFixed(2);
  if (!f.Tutarlar.FaturaToplam) f.Tutarlar.FaturaToplam= +(sumNet + sumTax).toFixed(2);

  f.Serbest = (typeof f.Serbest === 'boolean') ? f.Serbest : true;
  f.AlisSatis = false;
  return f;
}







export default {
    props: {
        operation: ''
    },

    data() {
        return {
            PB:'TRY',
            ocrBusy: false,
    ocrProgressDialog: false,
    ocrNoticeDialog: false,
    ocrDraft: null,
    lastOcrJson: null,
            calculateDisabled:false,
            dovizliFaturami: false,
            guncelledisabled: false,
            iadevalid: true,
            sayfayetki: {
                Screen: false,
                Update: false,
                Save: false,
                Delete: false,
                Status: false,
                Message: null,
                islem: 0,
            },

            degisenkayit: null,
            dizayngoster: true,
            yazdirbtngoster: false,
            efaturatipi: [{
                    text: this.$t('Commercial'),
                    value: '0'
                },
                {
                    text: this.$t('Basic'),
                    value: '1'
                },
                {
                    text: this.$t('Export'),
                    value: '2'
                },{
                    text: this.$t('Public'),
                    value: '3'
                }
            ],
            silinecekkayit: null,
            dialogsor: false,
            efaturatipigecici: 0,
            webadresilabel: null,
            odemeseklilabel: null,
            odemesekliaciklamalabel: null,
            odemearacilabel: null,
            odemetarihilabel: null,
            internetsatislabel: null,
            gonderimlabel: null,

            valid: true,
            Current: {
                CompanyCode: '',
                Code: null,
                Title: null,
                Phone1: '',
                CreditLimit1: 0,
                AccountingCode: null,
                Phone2: '',
                Mobile: '',
                Web: '',
                Email: '',
                AccountGroup: '',
                Type: '',
                CMCode: '',
                Reserved1: '',
                Reserved2: '',
                Authorized: '',
                WarningNote: '',
                InfoNote: '',
                CustomerType: '',
                TicketBill: '',
                EInvoiceType: '',
                PostCodeLabel: '',
                EInvoiceCustomer: '',
                MultiPostUse: false,
                EArchiveSendType: false,
                EArchiveSendPaper: false,
                CreditLimit: 0,
                CreditLimitCurrencyAmount: 0,
                CreditLimitCurrency: '',
                WebPassword: '',
                PinCode: '',
                MileCode: '',
                ExpiryDayDomestic: '',
                ExpiryTypeDomestic: '',
                ExpiryDayInt: '',
                ExpiryTypeInt: '',
                ExpiryDayGeneral: '',
                ExpiryTypeGeneral: '',
                DiscountGeneral: '',
                DiscountDom: '',
                DiscountInt: '',
                DiscountDomService: '',
                DiscountIntService: '',
                TaxFree: '',
                ExternalCurrentCode: '',
                ExternalAccountingCode: '',
                StreamCurrentCode: '',
                ArkmanStreamCode: '',
                ExpenseCenter: null,
                TemplateID: '',
                ProfileForced: '',
                EventIDForced: '',
                MainAccount: '',
                Invoice: {
                    Address: '',
                    PostCode: '',
                    Province: '',
                    Country: '',
                    TaxNumber: '',
                    TaxOffice: '',
                    IdentityNumber: '',
                    PerFirstName: '',
                    PerFamilyName: '',
                    PerTitle: '',
                    PerMiddleName: '',
                    PerNameSuffix: '',
                    NoPrint: '',
                    CustomerPersonelNoInvoice: '',
                    DeliveryAddress: '',
                    DeliveryName: ''
                },
                Contract: {
                    ContractNumber: '',
                    ContractDate: '',
                    PaymentType: '',
                    BankAccountNumber: '',
                    BankBranchOffice: '',
                    InvoiceRowNumber: '',
                    InvoicePassengerName: '',
                    InvoiceFlightNumber: ''
                }
            },

            musteritipi: [{
                    text: this.$t('Individual'),
                    value: 'B'
                },
                {
                    text: this.$t('Corporate'),
                    value: 'K'
                }
            ],
            dialogyenicari: false,
            reportbroview: false,
            headers: [{
                    text: 'Muh. Kod',
                    value: 'MuhasebeKodu'
                },
                {
                    text: this.$t('Description'),
                    value: 'Aciklama',

                },
                {
                    text: this.$t('Reference'),
                    value: 'Referans.Kod'
                },
                {
                    text: 'Tutar',
                    value: 'Tutar',
                },
                {
                    text: this.$t('Currency-Amount'),
                    value: 'DovizTutar',
                },
                {
                    text: this.$t('VAT-Percentage-v2'),
                    value: 'KdvYuzde',
                },
                {
                    text: this.$t('VAT-Amount'),
                    value: 'KdvTutar',
                },
                {
                    text: 'Tip',
                    value: 'Tip',
                },
                {
                    text: this.$t('Discount-Percentage'),
                    value: 'IskontoYuzde',
                },
                {
                    text: this.$t('Process'),
                    value: '',
                }
            ],
            guncelleMiktarKontrol:0,
            gibserigoster: true,
            autocomplete: 'autocomplete',
            drawer: null,
            baslik: '',
            e1: 0,
            Code: '',
            e2: true,
            yok: false,
            statesecili: [{
                Kod: 'Kod',
                Unvan: 'Unvan',
                newProp: 'Kod' + ' - ' + 'Unvan'
            }],
            statecari: [],
            secilensatirno: -1,
            search3: '',
            search1: '',
            loading: false,
            caritext: '',
            cariid: '',
            aktifdate: false,
            nefaturasi: 'serbest',

            SerbestFatura: {
                SirketKodu: '',
                SerbestFaturaDetay: [],
                Serbest: true,
                AlisSatis: false,
                FaturaSeri: '',
                FaturaNo: '',
                Update: false,
                Dovizli: false,
                FaturaTip: 0, // 0 : Satış faturası , 1 : Iade Faturası
                Evrak: {
                    Evrakkod: ''
                },
                Cari: {
                    Kod: ''
                },
                EFaturaBilgi: {
                    Unvani: '',
                    Unvani2: '',
                    Adres1: '',
                    Adres2: '',
                    IlceSehir: '',
                    Email: '',
                    VergiDairesi: '',
                    VergiNo: '',
                    TcKimlikNo: '',
                    Adi: '',
                    Soyadi: '',
                    TUnvani: '',
                    DigerAdi: '',
                    OnAdiEki: '',
                },
                Tarih: null,
                GibSeri: '',
                Vade: null,
                Referans: {
                    Kod: ''
                },
                Masraf: {
                    Code: ''
                },
                Aciklama: '',
                Doviz: {
                    DovizKod: ''
                },
                FTimeStamp:null,
                FaturaUnique:null,
                Kur: 0,
                TevkivatKdv: 0,
                FaturaID: 0,
                CariAktarma: false,
                Tutarlar: {
                    ToplamTutar: 0,
                    Iskonto: 0,
                    FaturaToplam: 0,
                    Kdv: 0,
                    TevkifatKdv: 0
                },
                Efaturakayit: false,
                Earchiveakayit: false,
                Kagitfatura: false,
                EarsivBilgi: {
                    GonderimSekli: '',
                    InternetSatis: '',
                    pWebAdresi: '',
                    OdemeSekli: '',
                    OdemeSekliAciklama: '',
                    OdemeAraci: '',
                    OdemeTarihi: ''
                },
                EFaturaShowID: {
                    EFaturaID: null,
                    EFaturaGuid: null,
                    FaturaStatus: null,
                    PdfID: null,
                    DizaynID: null,
                    XsltID: null

                },
                IadeFaturaBilgi: {
                    IadeNedeni: null,
                    IstinadenFaturaSeri: null,
                    IstinadenFaturaNo: null,
                    IstinadenFaturaTarihi: null
                }
            },
            SerbestFaturaDetayList: [],

            SerbestFaturaDetay: {
                MuhasebeKodu: '',
                Aciklama: '',
                LineNote: '',
                Referans: {
                    Kod: ''
                },
                Masraf: {
                    Code: ''
                },
                Miktar: 0,
                Birim: '',
                BirimFiyat: 0,
                Tutar: 0,
                DovizTutar: 0,
                IskontoYuzde: 0,
                IskontoTutar: 0,
                KdvTip: 'D',
                KdvYuzde: 0,
                KdvTutar: 0,
                KdvMuhKodu: '',
                IskMuhKodu: '',
                KdvKodu: '',
                IstisnaKodu: '',
                TevkifatKodu: '',
                Tip: '',
                TevkifatDetayTutar: 0,
                TevkifatDetayOran: 0,

                TeslimBilgileri: {
                    SokakAdi: '',
                    BinaAdi: '',
                    BinaNo: '',
                    TeslimSehir: '',
                    TeslimPostaKodu: '',
                    TeslimUlke: '',
                    TeslimSarti: '',
                    GTIPNo: '',
                    TransferKodu: '',
                    KabinNo: '',
                    KabinAdedi: '',
                    KabinCinsi: '',
                    TeslimOdeme: ''
                }

            },

            SerbestFaturaToplamTutarBilgileri: {
                ToplamTutar: 0,
                Iskonto: 0,
                FaturaToplam: 0,
                Kdv: 0,
                TevkifatKdv: 0
            },

            birim: [{
                    text: 'adet',
                    value: 'adet'
                },
                {
                    text: 'kilo',
                    value: 'kilo'
                }, {
                    text: this.$t('gram'),
                    value: 'gram'
                }, {
                    text: this.$t('meter'),
                    value: 'metre'
                },
                {
                    text: 'litre',
                    value: 'litre'
                },
                {
                    text: 'm2',
                    value: 'm2'
                },
                {
                    text: 'dm2',
                    value: 'dm2'
                },
                {
                    text: 'm3',
                    value: 'm3'
                },
            ],
            faturatipi: [{
                    text: this.$t('Sales-Invoice'),
                    value: 0
                },
                {
                    text: this.$t('Return-Invoice'),
                    value: 1
                }
            ],
            gonderimsekli: [{
                    text: this.$t('Paper'),
                    value: 0
                },
                {
                    text: this.$t('Electronic'),
                    value: 1
                }
            ],

            odemesekli: [{
                    text: this.$t('Normal-Sales'),
                    value: 0
                },
                {
                    text: this.$t('Internet-Sales'),
                    value: 1
                }
            ],
            seridisable: false,
            faturagosterbtn: false,
            date: null,
            menu: false,
            modal: false,
            dateFormatted: '',

            datearsiv: null,
            menuarsiv: false,
            modalarsiv: false,
            dateFormattedarsiv: '',
            yedeksatirkayit: {
                Tutar: 0,
                Kdv: 0,
                Tevkifat: 0,
                iskonto: 0
            },
            date2: null,
            menu2: false,
            dateFormatted2: '',
            modal2: false,
            ihracat: false,
            progress: false,
            satirdialog: false,
            iadedialog: false,
            gibseri: [],
            satiritems: [],
            referaslist: [],
            EvrakTipi1: [],
            kdvtipi: [{
                    text: 'D',
                    value: 'D'
                },
                {
                    text: 'H',
                    value: 'H'
                }
            ],
            Tevkifat: [{
                    text: '0/10',
                    value: 0
                },
                {
                    text: '1/10',
                    value: 0.1
                },
                {
                    text: '2/10',
                    value: 0.2
                },
                {
                    text: '3/10',
                    value: 0.3
                },
                {
                    text: '4/10',
                    value: 0.4
                },
                {
                    text: '5/10',
                    value: 0.5
                },
                {
                    text: '6/10',
                    value: 0.6
                },
                {
                    text: '7/10',
                    value: 0.7
                },
                {
                    text: '8/10',
                    value: 0.8
                },
                {
                    text: '9/10',
                    value: 0.9
                },
                {
                    text: '10/10',
                    value: 1
                }
            ],

            odemesekli1: [{
                    text: this.$t('Credit-Debit-Card'),
                    value: '0'
                },
                {
                    text: 'EFT-' + this.$t('Transfer-v3'),
                    value: '1'
                },
                {
                    text: this.$t('Cash-on-delivery'),
                    value: '2'
                },
                {
                    text: this.$t('Payment-Intermediary'),
                    value: '3'
                },
                {
                    text: this.$t('Other'),
                    value: '4'
                }
            ],

            transferkodu: [{
                    text: this.$t('Seaways'),
                    value: 1
                },
                {
                    text: this.$t('Railway'),
                    value: 2
                },
                {
                    text: this.$t('Highway'),
                    value: 3
                },
                {
                    text: this.$t('Airline'),
                    value: 4
                },
                {
                    text: this.$t('Post'),
                    value: 5
                },
                {
                    text: this.$t('Multiple-Vehicles'),
                    value: 6
                },
                {
                    text: this.$t('Fixed-Transportation-Complexes'),
                    value: 7
                },
                {
                    text: this.$t('Territorial-Water-Transportation'),
                    value: 8
                }
            ],

            teslimodeme: [{
                    text: 'Instrument not defined',
                    value: 1
                },
                {
                    text: 'Automated clearing house credit',
                    value: 2
                },
                {
                    text: 'Automated clearing house debit',
                    value: 3
                },
                {
                    text: 'ACH demand debit reversal',
                    value: 4
                },
                {
                    text: 'ACH demand credit reversal',
                    value: 5
                },
                {
                    text: 'ACH demand credit',
                    value: 6
                },
                {
                    text: 'ACH demand debit',
                    value: 7
                },
                {
                    text: 'Hold',
                    value: 8
                },
                {
                    text: 'National or regional clearing',
                    value: 9
                },
                {
                    text: 'In cash',
                    value: 10
                },
                {
                    text: 'ACH savings credit reversal',
                    value: 11
                },
                {
                    text: 'ACH savings debit reversal',
                    value: 12
                },
                {
                    text: 'ACH savings credit',
                    value: 13
                },
                {
                    text: 'ACH savings debit',
                    value: 14
                },
                {
                    text: 'Bookentry credit',
                    value: 15
                },
                {
                    text: 'Bookentry debit',
                    value: 16
                },
                {
                    text: 'ACH demand cash concentration/disbursement (CCD) credit',
                    value: 17
                },
                {
                    text: 'ACH demand cash concentration/disbursement (CCD) debit',
                    value: 18
                },
                {
                    text: 'ACH demand corporate trade payment (CTP) credit',
                    value: 19
                },
                {
                    text: 'Cheque',
                    value: 20
                },
                {
                    text: 'Bankers draft',
                    value: 21
                },
                {
                    text: 'Certified bankers draft',
                    value: 22
                },
                {
                    text: 'Bank cheque (issued by a banking or similar establishment)',
                    value: 23
                },
                {
                    text: 'Certified cheque',
                    value: 25
                },
                {
                    text: 'Local cheque',
                    value: 26
                },
                {
                    text: 'ACH demand corporate trade payment (CTP) debit',
                    value: 27
                },
                {
                    text: 'ACH demand corporate trade exchange (CTX) credit',
                    value: 28
                },
                {
                    text: 'ACH demand corporate trade exchange (CTX) debit',
                    value: 29
                },
                {
                    text: 'Credit transfer',
                    value: 30
                },
                {
                    text: 'Debit transfer',
                    value: 31
                },
                {
                    text: 'ACH demand cash concentration/disbursement plus (CCD+)',
                    value: 32
                },
                {
                    text: 'ACH demand cash concentration/disbursement plus (CCD+)',
                    value: 33
                },
                {
                    text: 'ACH prearranged payment and deposit (PPD)',
                    value: 34
                },
                {
                    text: ' ACH savings cash concentration/disbursement (CCD) credit',
                    value: 35
                },
                {
                    text: 'ACH savings cash concentration/disbursement (CCD) debit',
                    value: 36
                },
                {
                    text: 'ACH savings corporate trade payment (CTP) credit',
                    value: 37
                },
                {
                    text: 'ACH savings corporate trade payment (CTP) debit',
                    value: 38
                },
                {
                    text: 'ACH savings corporate trade exchange (CTX) credit',
                    value: 39
                },
                {
                    text: 'ACH savings corporate trade exchange (CTX) debit',
                    value: 40
                },
                {
                    text: 'ACH savings cash concentration/disbursement plus (CCD+)',
                    value: 41
                },
                {
                    text: 'Payment to bank account',
                    value: 42
                },
                {
                    text: 'ACH savings cash concentration/disbursement plus (CCD+)',
                    value: 43
                },
                {
                    text: 'Accepted bill of exchange',
                    value: 44
                },
                {
                    text: 'Referenced home-banking credit transfer',
                    value: 45
                },
                {
                    text: 'Interbank debit transfer',
                    value: 46
                },
                {
                    text: 'Home-banking debit transfer',
                    value: 47
                },
                {
                    text: 'Bank card',
                    value: 48
                },
                {
                    text: 'Direct debit',
                    value: 49
                },
                {
                    text: 'Payment by postgiro',
                    value: 50
                },
                {
                    text: 'Promissory note',
                    value: 60
                },
                {
                    text: '61    Promissory note signed by the debtor',
                    value: 61
                },
                {
                    text: 'Promissory note signed by the debtor and endorsed by a bank',
                    value: 62
                },
                {
                    text: 'Promissory note signed by the debtor and endorsed by a',
                    value: 63
                },
                {
                    text: ' Promissory note signed by a bank',
                    value: 64
                },
                {
                    text: 'Promissory note signed by a bank and endorsed by another',
                    value: 65
                },
                {
                    text: 'Promissory note signed by a third party',
                    value: 66
                },
                {
                    text: 'Promissory note signed by a third party and endorsed by a',
                    value: 67
                },
                {
                    text: 'Bill drawn by the creditor on the debtor',
                    value: 70
                },
                {
                    text: 'Bill drawn by the creditor on a bank',
                    value: 74
                },
                {
                    text: 'Bill drawn by the creditor, endorsed by another bank',
                    value: 75
                },
                {
                    text: 'Bill drawn by the creditor on a bank and endorsed by a',
                    value: 76
                },
                {
                    text: 'Bill drawn by the creditor on a third party',
                    value: 77
                },
                {
                    text: 'Bill drawn by creditor on third party, accepted and',
                    value: 78
                },
                {
                    text: 'Not transferable banker s draft',
                    value: 91
                },
                {
                    text: 'Not transferable local cheque',
                    value: 92
                },
                {
                    text: 'Reference giro',
                    value: 93
                },
                {
                    text: 'Urgent giro',
                    value: 94
                },
                {
                    text: 'Free format giro',
                    value: 95
                },
                {
                    text: 'Requested method for payment was not used',
                    value: 96
                },
                {
                    text: 'Clearing between partners',
                    value: 97
                }

            ],
            islembilgileri: [{
                    text: this.$t('Hard-Copy-Invoice'),
                    value: 'false'
                },
                {
                    text: this.$t('Electronic-Invoice'),
                    value: 'true'
                }
            ],

            doviztipi: [],
            webadresleri: [],
            odemesekilleri: [],
            odemearaci: [],
            dizayn: null,

            ichattipi: [
                'D', 'D-', 'D+', 'K', 'K-', 'K+', 'U', 'U-', 'U+', 'L', 'L-', 'L+'
            ],

            evethayir: [{
                    text: this.$t('Yes'),
                    value: 'E'
                },
                {
                    text: 'Hayır',
                    value: 'H'
                },
            ],

            cmkodu: [
                'C', 'M'
            ],
            dizaynsec: [],
            xsltitems: [],
            masrafmerkezi: [],
            dictionary: {
                custom: {
                    carikod: {
                        required: () => this.$t('This-space-cannot-left-blank'),
                    },
                    unvan: {
                        required: () => this.$t('This-space-cannot-left-blank'),
                    },
                    faturaseri: {
                        required: () => this.$t('This-space-cannot-left-blank'),
                    },
                    faturano: {
                        required: () => this.$t('This-space-cannot-left-blank'),
                    },

                    dizayn: {
                        required: () => this.$t('This-space-cannot-left-blank'),
                    },
                    xslt: {
                        required: () => this.$t('This-space-cannot-left-blank'),
                    },
                    gtip: {
                        min: () => this.$t('Must-least-4-digits'),
                    }

                }
            },
            sayfabaslik: this.$t('Free-Invoice'),
            satirguncellebuton: false,
            satirkaydetbuton: true,
            StartDate: null,
            EndDate: null,
            NumberOfPolicies: '',
            PolicySum: '',
            TotalDebt: '',
            TotalFlatDebt: '',
            kaydetbuton: true,
            guncellebuton: false,
            silbuton: false,
            detaytevkifat: true,
            text1: '',
            lastOcrJson: null,
            ocrBusy: false,
            
            denemevalue: 0,

            biletlerfaturalanmasin: null,
            efaturamukellefi: null,
            loadingdialog: false,
            Kdvmuaf: null,
            ciktiistemiyor: null,
            musteribilgitipi: null,
            profilzorunlu: null,
            eventidzorunlu: null,
            snackbar: false,
            y: 'top',
            x: 'right',
            GetControl:0,
            mode: '',
            timeout: 6000,
            carikod: '',
            unvan: '',
            active: '',
            ex11: 'false',
            dialogearsiv: false,
            earsivdurum: false,
            guidim: null,
            idim: null,
            faturadialog: false,
            kredilimiti: 0,
            dizaynIdget: null,
            xsltIdget: null,
            faturasilbtn: false,
            satirsilbtn: false,
            islemturu: null,
            dialogdegistir: false,
            ChangeTarih: null,
            ChangeFaturaNo: null,
            counter:0,
            kdvShow:true,
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from.path
        })
    },
    mounted() {
        this.$validator.localize('en', this.dictionary)

        this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
console.log(this.$route.name);
        if (this.sayfayetki.Status == true) {

            this.SerbestFaturaDetayList = []

            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            this.PB=credentials.ParaBirimi;
            var params1 = {
                CompanyCode: credentials.SirketKodu,
            }

            this.$http.post(auth.API_URL + 'api/doctype/List', params1, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.EvrakTipi1 = response.body
                if(this.$route.query.islem == "yenigelenevrak"){
                    this.SerbestFatura.Evrak.Evrakkod = 'AF';
                }else{
                this.SerbestFatura.Evrak.Evrakkod = 'SF';
                }
            }, (response) => {
                if (response.status === 0) {} else {}
            })

            this.$http.post(auth.API_URL + 'api/currency/List', params1, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.doviztipi = response.body
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-Döviz Tipi'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable-Döviz Tipi'
                    this.snackbar = true
                }
            })

            if (this.$route.query.islem == "yeni" || this.$route.query.islem == "get") {
                this.nefaturasi = 'serbest'
                if (this.$route.query.islem == "get") {
                    this.yazdirbtngoster = true
                }
                this.dizayngoster = true
                this.dizayngetir()
            }

            if (this.$route.query.islem == "yenigelenevrak" || this.$route.query.islem == "gelenevrak") {
                this.kdvShow = false;
                this.yazdirbtngoster = false
                this.dizayngoster = false
                this.nefaturasi = 'gelen'
                this.faturatipi = [];
                var kayit = {
                    text: this.$t('Free-Purchase-Invoice'),
                    value: 0
                }
                this.faturatipi.push(kayit);
                kayit = {
                    text: this.$t('Sales-Return'),
                    value: 1
                }
                this.faturatipi.push(kayit);

                this.SerbestFatura.GibSeri = null,
                    this.gibserigoster = false;
                this.gibseri = [];
                this.sayfabaslik =  this.$t('Invoice-Received');
                this.SerbestFatura.CariAktarma = false;
            }

            if (this.$route.query.islem == "get" || this.$route.query.islem == "gelenevrak") {
                this.loadingdialog = true
                this.guncellebuton = true
                this.kaydetbuton = false
                this.seridisable = true

                this.getcari(this.$route)

                var params2 = {
                    SirketKodu: credentials.SirketKodu,
                    Tarih: this.$route.query.ft,
                    CariKod:this.$route.query.ck, // this.$route.query.ck,
                    EvrakTipi: '',
                    EvrakSeri: this.$route.query.es,
                    Evrakno: this.$route.query.en,
                    Nereden: this.$route.query.ner,
                    Serbest: this.$route.query.sb,
                }
console.log(params2);
console.log(this.$route.query.ck);
                this.$http.post(auth.API_URL + 'api/Invoice/FreeInvoiceGet', params2, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    if(response.body.EFaturaBilgi==null)
                    {
                        response.body.EFaturaBilgi = 
                            {
                                Unvani: '',
                                Unvani2: '',
                                Adres1: '',
                                Adres2: '',
                                IlceSehir: '',
                                Email: '',
                                VergiDairesi: '',
                                VergiNo: '',
                                TcKimlikNo: '',
                                Adi: '',
                                Soyadi: '',
                                TUnvani: '',
                                DigerAdi: '',
                                OnAdiEki: '',
                            }
                    }
                    this.SerbestFatura = response.body

                    //cariyi dolduruyoruz
                    var statecariyeni = [{
                        autoText: response.body.Cari.Kod + '-' + response.body.Cari.Unvan,
                        unvan1: response.body.Cari.Kod + '-' + response.body.Cari.Unvan,
                        id: response.body.Cari.Kod
                    }]
                    this.statecari = statecariyeni
                    
                    if (response.body.EFaturaShowID != null) {
                        if (response.body.EFaturaShowID.FaturaStatus != 'Fatura Beklemede' && this.$route.query.islem ==
                            "get") {
                            this.guncelledisabled = true
                        } else {
                            this.guncelledisabled = false
                        }
                    }

                    this.satiritems = response.body.Detay
                    this.loadingdialog = false

                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                        this.loadingdialog = false

                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                        this.loadingdialog = false
                    }
                })
            }

        } else {

            this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

                if (sonuc == true) {

                    if (this.prevRoute != null) {
                        var url = '#' + this.prevRoute

                        window.open(url, '_self')
                    } else {
                        var url = '#/'
                        window.open(url, '_self')
                    }
                } else {

                }

            });

        }
        
    },
    filters: {
        dateformat: function (t) {
            return helpers.dateformat(t);
        },
        moneyformat: function (m) {
            return helpers.moneyformat(m);
        },

        bakiyekontrol: function (m) {
            return helpers.bakiyekontrol(m);
        }
    },
    
    methods: {
        openOcr() { if (this.$refs.ocrFile) this.$refs.ocrFile.click(); },

  handleOcrFile(e) {
    const file = e && e.target && e.target.files && e.target.files[0];
    if (!file) return;

    const fd = new FormData();
    fd.append('file', file);

    this.ocrBusy = true;
    this.ocrProgressDialog = true;

    const self = this;
    this.$http.post(auth.API_URL + 'api/ocr/to-json?engine=auto', fd, {
      headers: { Authorization: 'Bearer ' + auth.getAuthHeader() }
    }).then(function(res){
      self.lastOcrJson = res.body;
      // taslak modeli hazırla (kullanıcı onaylayınca forma yazacağız)
      self.ocrDraft = mapOcrToSerbestFatura(res.body, self.SerbestFatura);
      // progress kapat, uyarıyı göster
      self.ocrProgressDialog = false;
      self.ocrNoticeDialog = true;
      if (e && e.target) e.target.value = '';
    }).catch(function(err){
      console.error('OCR Hatası:', err);
      self.ocrProgressDialog = false;
      self.text1 = 'OCR servis hatası';
      self.snackbar = true;
      if (e && e.target) e.target.value = '';
    }).finally(function(){
      self.ocrBusy = false;
    });
  },

  cancelOcrImport(){
    this.ocrNoticeDialog = false;
    this.ocrDraft = null;
  },
  confirmOcrImport(){
    if (!this.ocrDraft) { this.ocrNoticeDialog = false; return; }
    this.SerbestFatura = this.ocrDraft;
    this.satiritems = Array.isArray(this.SerbestFatura.SerbestFaturaDetay)
      ? this.SerbestFatura.SerbestFaturaDetay : [];
    this.faturatoplambul();
    this.ocrNoticeDialog = false;
  },

        satirDialogIptal(){
            this.satirdialog = false;
            this.guncelleMiktarKontrol = 0;
        },  
        dovizlitutarhesapla(){
            if (this.SerbestFaturaDetay.Miktar > 0 && this.SerbestFaturaDetay.BirimFiyat >= 0) {
                this.SerbestFaturaDetay.DovizTutar = this.SerbestFaturaDetay.Miktar * this.SerbestFaturaDetay.BirimFiyat
                 if (this.SerbestFatura.Kur != null && this.SerbestFatura.Kur != 0 && this.SerbestFatura.Dovizli == true) {
                    this.SerbestFaturaDetay.DovizTutar = this.SerbestFaturaDetay.Miktar * this.SerbestFaturaDetay.BirimFiyat
                   // this.SerbestFaturaDetay.DovizTutar = this.SerbestFaturaDetay.Tutar / this.SerbestFatura.Kur
                   this.SerbestFaturaDetay.Tutar = this.SerbestFaturaDetay.DovizTutar * this.SerbestFatura.Kur
                 }else{
                    this.SerbestFaturaDetay.Tutar = this.SerbestFaturaDetay.Miktar * this.SerbestFaturaDetay.BirimFiyat
                 }
            } else {
                this.SerbestFaturaDetay.Tutar = 0
            }
        },
        YuzdeKontrol(){
            if(this.SerbestFaturaDetay.IskontoYuzde != 0 && this.SerbestFaturaDetay.IskontoYuzde !== 'undefined'){
                this.SerbestFaturaDetay.IskontoTutar = this.SerbestFaturaDetay.Tutar / 100 * this.SerbestFaturaDetay.IskontoYuzde
            }
        },
        satirDovizOdakKaybi(val) {

            if (this.SerbestFatura.Kur != 0) {
                if (this.SerbestFaturaDetay.DovizTutar != 0) {
                    this.SerbestFaturaDetay.Tutar = this.SerbestFaturaDetay.DovizTutar * this.SerbestFatura.Kur
                }
            } else {
                if (this.SerbestFaturaDetay.DovizTutar != 0) {

                    this.SerbestFaturaDetay.Tutar = this.SerbestFaturaDetay.DovizTutar * this.SerbestFatura.Kur
                }
            }

        },
        getcari(val) {
            val = decodeURI(window.location.href)
            var str1 = val.split("&ck=")
            var str2 = str1[1].split("&et")
            return str2[0]

        },

        getparabirimi() {
            return helpers.getparabirimi()
        },
        getdefaultparabirimi: function (m) {
            return helpers.getparabirimiDefault(m)
        },
        faturatoplambul() {
            this.SerbestFatura.Tutarlar.FaturaToplam = 0

            this.satiritems.forEach(element => {

                if (element.KdvTip == 'H') {
                    this.SerbestFatura.Tutarlar.FaturaToplam = this.SerbestFatura.Tutarlar.FaturaToplam + element
                        .Tutar +
                        element
                        .KdvTutar
                } else {

                    this.SerbestFatura.Tutarlar.FaturaToplam = this.SerbestFatura.Tutarlar.FaturaToplam + element
                        .Tutar
                }

            });
             this.SerbestFatura.Tutarlar.FaturaToplam = this.SerbestFatura.Tutarlar.FaturaToplam - this.SerbestFatura.Tutarlar.Iskonto - this.SerbestFatura.Tutarlar.TevkifatKdv
        },

        faturanotarihdegistir(tur) {
            //tur 0 ise faturatarih 1 ise tarih

            this.dialogdegistir = true;
            if (tur == 0) {
                this.islemturu = 0;
                this.ChangeFaturaNo = this.SerbestFatura.FaturaNo
                this.ChangeTarih = null
            } else if (tur == 1) {
                this.ChangeTarih = this.SerbestFatura.Tarih
                this.ChangeFaturaNo = null
                this.islemturu = 1;
            }

        },
        dizayngetir() {
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            var params = {
                SirketKodu: credentials.SirketKodu,
                FaturaTip: 'S',
                DovizliFatura: this.SerbestFatura.Dovizli,
                HatTipi: false,
                TumFiltre: true
            }

            this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableList', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.dizaynsec = response.body
            }, (response) => {
                if (response.status === 0) {
                    this.progress = false
                    this.text1 = 'Service Unavailable-InvoiceXsltTableList'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable-InvoiceXsltTableList'
                    this.snackbar = true
                }
            })

        },
        Yazdir() {
            this.dizaynbilgigetir(this.SerbestFatura.EFaturaShowID.DizaynID);

            if (this.SerbestFatura.EFaturaShowID.PdfID != 0) {
                var prm = {
                    id: this.SerbestFatura.EFaturaShowID.EFaturaID,
                    guid: this.SerbestFatura.EFaturaShowID.EFaturaGuid
                };

                this.$refs.reportbrosablon.Print(prm, this.SerbestFatura.EFaturaShowID.PdfID).then(
                    confirm => {
                        if (confirm.sonuc == true) {

                        } else {
                            this.text1 = confirm.mesaj
                            this.snackbar = true
                        }
                    });
            } else {
                this.text1 = this.$t('design-you-selected-does-include-invoice-present-design-Invoice-screen')
                this.snackbar = true
            }
        },
        xsltgetir() {
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            var paramsxslt = {
                CompanyCode: credentials.SirketKodu,

            }
            this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableList', paramsxslt, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.xsltitems = response.body

                this.SerbestFatura.EFaturaShowID.XsltID = this.xsltIdget;

            }, (response) => {
                if (response.status === 0) {
                    this.progress = false
                    this.text1 = 'Service Unavailable-InvoiceXsltTableList'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable-InvoiceXsltTableList'
                    this.snackbar = true
                }
            })

        },
        dizaynbilgigetir(Faturaid) {
            this.dizaynsec.forEach(element => {
                if (element.FaturaId == Faturaid) {
                    this.SerbestFatura.EFaturaShowID.XsltID = element.FaturaXsltId
                    this.SerbestFatura.EFaturaShowID.PdfID = element.FaturaPdfID
                }
            });
        },
        yenicarikaydet() {

            if (this.$refs.formcariyegore.validate()) {
                var credentials = JSON.parse(window.localStorage.getItem('credentials'));
                this.Current.CompanyCode = credentials.SirketKodu
                var current = this.Current
                this.$http.post(auth.API_URL + 'api/Current/New', current, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    if (response.body.Status === true) {

                        var seciliitems = [{
                        autoText: this.Current.Code + '-' + this.Current.Title,
                        unvan1: this.Current.Code + '-' + this.Current.Title,
                        id: this.Current.Code
                        }]

                        this.statecari = seciliitems
                        this.SerbestFatura.Cari.Kod = this.Current.Code;

                         this.text1 = this.$t(response.body.ResponseMessage)
                        this.snackbar = true

                        this.Current.Code = null;
                        this.Current.Title = null;
                        this.Current.Phone1 = null;
                        this.Current.Email = null;
                        this.Current.Authorized = null;
                        this.Current.CustomerType = null;
                        this.Current.EInvoiceType = null;
                        this.Current.EArchiveSendType = false;
                        this.Current.Invoice.Address = null;
                        this.Current.Invoice.PostCode = null;
                        this.Current.Invoice.Province = null;
                        this.Current.Invoice.Country = null;
                        this.Current.Invoice.TaxNumber = null;
                        this.Current.Invoice.TaxOffice = null;
                        this.Current.Invoice.IdentityNumber = null;
                        this.Current.Invoice.PerFirstName = null;
                        this.Current.Invoice.PerFamilyName = null;
                        this.Current.Invoice.PerTitle = null;
                        this.Current.Invoice.PerMiddleName = null;
                        this.Current.Invoice.PerNameSuffix = null;
                        this.Current.Invoice.CustomerPersonelNoInvoice = null;
                        this.Current.Invoice.DeliveryAddress = null;
                        this.Current.Invoice.DeliveryName = null;

                        this.cariislemler();

                        this.dialogyenicari = false;

                    } else if (response.body.Status === false) {
                         this.text1 = this.$t(response.body.ResponseMessage)
                        this.snackbar = true
                    }
                }, (response) => {
                    if (response.status === 0) {
                         this.text1 = this.$t(response.body.ResponseMessage)
                        this.snackbar = true
                    } else {
                       
                        let data ={
                        response: response,
                        request: current,
                        api:'Current/New',
                        type:2,
                        message: response.body.ExceptionMessage
                        };
                        this.$refs.showMessage.open(data);

                    }
                })
            } else {
                this.text1 = this.$t('Please-fill-required-fields');
                this.snackbar = true
            }
        },
        satirguncellekaydet() {


            var islem = false

            if (this.$route.query.islem == "yenigelenevrak")
            {
                if (this.SerbestFaturaDetay.KdvYuzde == 0)
                {
                    this.SerbestFaturaDetay.KdvKodu = '0015'
                }
                islem=true
            }
else
{
    if (this.SerbestFaturaDetay.KdvYuzde == 0) {

this.SerbestFaturaDetay.KdvKodu = '0015'

if ( this.SerbestFaturaDetay.IstisnaKodu != null && this.SerbestFaturaDetay.IstisnaKodu != '') {

    if ((this.SerbestFatura.TevkivatKdv != null && this.SerbestFatura.TevkivatKdv != '') || (this
            .SerbestFaturaDetay
            .TevkifatDetayOran != '' && this.SerbestFaturaDetay.TevkifatDetayOran != null)) {

        if (this.SerbestFaturaDetay.TevkifatKodu != null && this.SerbestFaturaDetay.TevkifatKodu != '') {
            islem = true
        } else {
            this.text1 = 'Tevkifat Kodunu boş geçemezsiniz.'
            this.snackbar = true
            islem = false
        }
    } else {
        islem = true
    }
} else {
    islem = false
    this.text1 = this.$t('You-cannot-pass-the-exception-code-blank.')
    this.snackbar = true
}
} else {

if ( this.SerbestFaturaDetay.KdvKodu != null && this.SerbestFaturaDetay.KdvKodu != '') {

    if ((this.SerbestFatura.TevkivatKdv != null && this.SerbestFatura.TevkivatKdv != '') || (this
            .SerbestFaturaDetay
            .TevkifatDetayOran != '' && this.SerbestFaturaDetay.TevkifatDetayOran != null)) {

        if (this.SerbestFaturaDetay.TevkifatKodu != null && this.SerbestFaturaDetay.TevkifatKodu != '') {
            islem = true
        } else {
            this.text1 = 'Tevkifat Kodunu boş geçemezsiniz.'
            this.snackbar = true
            islem = false
        }
    } else {
        islem = true
    }

} else {
    this.text1 = 'KDV Kodunu boş geçemezsiniz.'
    this.snackbar = true
    islem = false

}
}
}


            if(islem == true){
                const index = this.secilensatirno

                var degisenkayit = {}

                var yedeksatiritems = []

                yedeksatiritems = this.satiritems

                this.satiritems = []

if (this.SerbestFaturaDetay.TevkifatDetayOran==0)
{
    this.SerbestFatura.Tutarlar.TevkifatKdv=0;
    this.yedeksatirkayit.Tevkifat=0;
}

                this.SerbestFatura.Tutarlar.ToplamTutar = this.SerbestFatura.Tutarlar.ToplamTutar - this.yedeksatirkayit
                    .Tutar
                this.SerbestFatura.Tutarlar.Kdv = this.SerbestFatura.Tutarlar.Kdv - this.yedeksatirkayit.Kdv

              
                this.SerbestFatura.Tutarlar.TevkifatKdv = this.SerbestFatura.Tutarlar.TevkifatKdv - this.yedeksatirkayit.Tevkifat
                   
                this.SerbestFatura.Tutarlar.Iskonto = this.SerbestFatura.Tutarlar.Iskonto - this.yedeksatirkayit.iskonto

                if (this.SerbestFaturaDetay.DovizTutar > 0) {
                    var n = this.SerbestFaturaDetay.DovizTutar

                }
                this.guncelleMiktarKontrol = 0;

                var satiryeni = {
                    TeslimBilgileri: {
                        SokakAdi: this.SerbestFaturaDetay.TeslimBilgileri.SokakAdi,
                        BinaAdi: this.SerbestFaturaDetay.TeslimBilgileri.BinaAdi,
                        BinaNo: this.SerbestFaturaDetay.TeslimBilgileri.BinaNo,
                        TeslimSehir: this.SerbestFaturaDetay.TeslimBilgileri.TeslimSehir,
                        TeslimPostaKodu: this.SerbestFaturaDetay.TeslimBilgileri.TeslimPostaKodu,
                        TeslimUlke: this.SerbestFaturaDetay.TeslimBilgileri.TeslimUlke,
                        TeslimSarti: this.SerbestFaturaDetay.TeslimBilgileri.TeslimSarti,
                        GTIPNo: this.SerbestFaturaDetay.TeslimBilgileri.GTIPNo,
                        TransferKodu: this.SerbestFaturaDetay.TeslimBilgileri.TransferKodu,
                        KabinNo: this.SerbestFaturaDetay.TeslimBilgileri.KabinNo,
                        KabinAdedi: this.SerbestFaturaDetay.TeslimBilgileri.KabinAdedi,
                        KabinCinsi: this.SerbestFaturaDetay.TeslimBilgileri.KabinCinsi,
                        TeslimOdeme: this.SerbestFaturaDetay.TeslimBilgileri.TeslimOdeme
                    },
                    MuhasebeKodu: this.SerbestFaturaDetay.MuhasebeKodu,
                    Aciklama: this.SerbestFaturaDetay.Aciklama,
                    Referans: {
                        Kod: this.SerbestFaturaDetay.Referans.Kod
                    },
                    Masraf: {
                        Code: this.SerbestFaturaDetay.Masraf.Code
                    },
                    Miktar: this.SerbestFaturaDetay.Miktar,
                    LineNote: this.SerbestFaturaDetay.LineNote,
                    Birim: this.SerbestFaturaDetay.Birim,
                    BirimFiyat: this.SerbestFaturaDetay.BirimFiyat,
                    Tutar: this.SerbestFaturaDetay.Tutar,
                    TevkifatDetayTutar: this.SerbestFaturaDetay.TevkifatDetayTutar,
                    DovizTutar: this.SerbestFaturaDetay.DovizTutar,
                    TevkifatDetayOran: this.SerbestFaturaDetay.TevkifatDetayOran,
                    IskontoYuzde: this.SerbestFaturaDetay.IskontoYuzde,
                    IskontoTutar: this.SerbestFaturaDetay.IskontoTutar,
                    KdvKodu: this.SerbestFaturaDetay.KdvKodu,
                    KdvMuhKodu: this.SerbestFaturaDetay.KdvMuhKodu, //
                    IskMuhKodu: this.SerbestFaturaDetay.IskMuhKodu, //
                    KdvTutar: this.SerbestFaturaDetay.KdvTutar,
                    KdvTip: this.SerbestFaturaDetay.KdvTip,
                    KdvYuzde: this.SerbestFaturaDetay.KdvYuzde,
                    IstisnaKodu: this.SerbestFaturaDetay.IstisnaKodu,
                    TevkifatKodu: this.SerbestFaturaDetay.TevkifatKodu,
                    Tip: this.SerbestFaturaDetay.Tip,
                    AdresBilgi: {
                        Unvani: null,
                        Unvani2: null,
                        Adres1: null,
                        Adres2: null,
                        IlceSehir: null,
                        Email: null,
                        VergiDairesi: null,
                        VergiNo: null,
                        TcKimlikNo: null,
                        Adi: null,
                        Soyadi: null,
                        TUnvani: null,
                        DigerAdi: null,
                        OnAdiEki: null
                    },
                    EfaturaDetayBilgileri: {
                        SiparisID: null,
                        SiparisTarihi: null
                    },
                    AdresBilgi: {
                        Unvani: null,
                        Unvani2: null,
                        Adres1: null,
                        Adres2: null,
                        IlceSehir: null,
                        Email: null,
                        VergiDairesi: null,
                        VergiNo: null,
                        TcKimlikNo: null,
                        Adi: null,
                        Soyadi: null,
                        TUnvani: null,
                        DigerAdi: null,
                        OnAdiEki: null
                    }
                }

                for (var i = 0; i < yedeksatiritems.length; i++) {
                    if (index == i) {
                        this.satiritems.push(satiryeni);
                    } else {
                        this.satiritems.push(yedeksatiritems[i]);
                    }
                }

                this.satirdialog = false;
                this.SerbestFatura.Tutarlar.ToplamTutar = this.SerbestFatura.Tutarlar.ToplamTutar + satiryeni.Tutar;
                this.SerbestFatura.Tutarlar.Kdv = this.SerbestFatura.Tutarlar.Kdv + satiryeni.KdvTutar;
                this.SerbestFatura.Tutarlar.TevkifatKdv = this.SerbestFatura.Tutarlar.TevkifatKdv + satiryeni.TevkifatDetayTutar;
                this.SerbestFatura.Tutarlar.Iskonto = this.SerbestFatura.Tutarlar.Iskonto + satiryeni.IskontoTutar;

                this.faturatoplambul();

            }
        },
        satirduzenle(params) {

            this.yedeksatirkayit.Tutar = params.Tutar
            this.yedeksatirkayit.Kdv = params.KdvTutar
            this.yedeksatirkayit.iskonto = params.IskontoTutar
            this.yedeksatirkayit.Tevkifat = params.TevkifatDetayTutar
            this.secilensatirno = this.satiritems.indexOf(params)
            this.degisenkayit = params
            this.secilenkdvtipi = params.KdvTip
            this.SerbestFaturaDetay = {...params}
            this.satirdialog = true
            this.satirguncellebuton = true
            this.satirkaydetbuton = false
        },
        satirsilsor(item) {
            this.dialogsor = true;
            this.faturasilbtn = false;
            this.satirsilbtn = true,
                this.silinecekkayit = item
        },
        faturasilsor() {
            this.dialogsor = true;
            this.faturasilbtn = true;
            this.satirsilbtn = false
        },
        satirsil() {

            const index = this.satiritems.indexOf(this.silinecekkayit)

            this.SerbestFatura.Tutarlar.ToplamTutar = this.SerbestFatura.Tutarlar.ToplamTutar - this.silinecekkayit
                .Tutar

            this.SerbestFatura.Tutarlar.Kdv = this.SerbestFatura.Tutarlar.Kdv - this.silinecekkayit.KdvTutar

            this.SerbestFatura.Tutarlar.TevkifatKdv = this.SerbestFatura.Tutarlar.TevkifatKdv - this.silinecekkayit
                .TevkifatDetayTutar

            this.SerbestFatura.Tutarlar.Iskonto = this.SerbestFatura.Tutarlar.Iskonto - this.silinecekkayit.IskontoTutar

            // if (this.silinecekkayit.KdvTip == 'H') {
            //   this.SerbestFatura.Tutarlar.FaturaToplam = this.SerbestFatura.Tutarlar.FaturaToplam - this.silinecekkayit
            //     .Tutar - this.silinecekkayit.KdvTutar - this.SerbestFatura.Tutarlar.Iskonto - this.SerbestFatura.Tutarlar
            //     .TevkifatKdv

            // } else {
            //   this.SerbestFatura.Tutarlar.FaturaToplam = this.SerbestFatura.Tutarlar.FaturaToplam - this.silinecekkayit
            //     .Tutar - this.SerbestFatura.Tutarlar.Iskonto - this.SerbestFatura.Tutarlar.TevkifatKdv
            // }

            // this.SerbestFatura.Tutarlar.FaturaToplam = this.SerbestFatura.Tutarlar.ToplamTutar - this.SerbestFatura.Tutarlar
            //   .Iskonto - this.SerbestFatura.Tutarlar.TevkifatKdv
            this.satiritems.splice(index, 1)
            this.dialogsor = false;
            this.faturatoplambul();
        },
        tarihkontrol(v) {

            if (v != "0001-01-01T00:00:00" && v != null) {
                var parts1 = v.split("-");
                return (parts1[2] + '-' + parts1[1] + '-' + parts1[0]);
            } else {
                return null;
            }
        },
        cariislemler() {

            var credentials = JSON.parse(window.localStorage.getItem('credentials'))
            var params = {
                Code: this.SerbestFatura.Cari.Kod,
                CompanyCode: credentials.SirketKodu
            }

            this.$http.post(auth.API_URL + 'api/Current/Get', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.unvan = response.body.Title

                if (response.body.CreditLimit == null || response.body.CreditLimit == '') {

                    this.kredilimiti = 0
                } else {
                    this.kredilimiti = 0
                }

                this.SerbestFatura.EFaturaBilgi.Unvani = response.body.Title
                this.SerbestFatura.EFaturaBilgi.Unvani2 = response.body.Title2
                this.SerbestFatura.EFaturaBilgi.Adres1 = response.body.Invoice.Address
                this.SerbestFatura.EFaturaBilgi.IlceSehir = response.body.Invoice.Province
                this.SerbestFatura.EFaturaBilgi.Email = response.body.Email
                this.SerbestFatura.EFaturaBilgi.VergiDairesi = response.body.Invoice.TaxOffice
                this.SerbestFatura.EFaturaBilgi.VergiNo = response.body.Invoice.TaxNumber
                this.SerbestFatura.EFaturaBilgi.TcKimlikNo = response.body.Invoice.IdentityNumber
                this.SerbestFatura.EFaturaBilgi.Adi = response.body.Invoice.PerFirstName
                this.SerbestFatura.EFaturaBilgi.Soyadi = response.body.Invoice.PerFamilyName
                this.SerbestFatura.EFaturaBilgi.TUnvani = response.body.Invoice.PerTitle
                this.SerbestFatura.EFaturaBilgi.DigerAdi = response.body.Invoice.PerMiddleName
                this.SerbestFatura.EFaturaBilgi.OnAdiEki = response.body.Invoice.PerNameSuffix

                var vadegun=response.body.ExpiryDayGeneral;
                if (vadegun!=null && vadegun!='undefined')
                {
                    try
                    {
                        var date = this.SerbestFatura.Tarih.split("-");
      var changeDate = new Date(date[0], date[1] - 1, date[2]);
      changeDate.setDate(changeDate.getDate() + vadegun);
      var formatDate = helpers.dateformat(changeDate);
      var parseFormDate = formatDate.split(".");
      var nextDate =parseFormDate[2] + "-" + parseFormDate[1] + "-" + parseFormDate[0];
        var nextDateTime = nextDate + "T00:00:00";
      this.SerbestFatura.Vade=nextDateTime;
                    }
                    catch
                    {

                    }
                   
                   
                   
                }
                
                
                if(this.GetControl > 0 && this.$route.query.islem == "get"){
                    this.SerbestFatura.Masraf.Code = response.body.ExpenseCenter;
                }
                this.GetControl++;
                if(this.$route.query.islem != "get"){
                    this.SerbestFatura.Masraf.Code = response.body.ExpenseCenter;
                }

                this.gonderimsekli.forEach(element => {
                if (response.body.EInvoiceType == element.value) {

                    this.gonderimlabel = element.text
                }
                });

                if (response.body.EArchiveSendType==true && response.body.EArchiveSendPaper==false)
                {
                    this.gonderimlabel=this.$t('Electronic')
                    this.SerbestFatura.EarsivBilgi.GonderimSekli=1;
                }
                this.efaturatipigecici = String(response.body.EInvoiceType);
                if(response.body.EInvoiceType == 2){
                    this.ihracat = true
                }else{
                    this.ihracat = false
                }
                //ana sirket e faturacı değilse kağıt fatura
                if (credentials.EFatura != '1') {

                    this.SerbestFatura.Efaturakayit = false
                    this.SerbestFatura.Earchiveakayit = false
                    this.SerbestFatura.KagitFatura = true
                }

                if (credentials.EFatura == '1' && response.body.EInvoiceCustomer == '1') {
                    // ana sirket efatura cari efatura o zaman efaturacı
                    this.SerbestFatura.Efaturakayit = true
                    this.SerbestFatura.Earchiveakayit = false
                    this.SerbestFatura.KagitFatura = false

                }

                if (credentials.EFatura == '1' && response.body.EInvoiceCustomer == '0') {
                    if (credentials.EArsiv == '1') {
                        //anasirket efatura cari earsiv  o zaman earşivci
                        this.SerbestFatura.Earchiveakayit = true
                        this.SerbestFatura.Efaturakayit = false
                        this.SerbestFatura.KagitFatura = false
                    } else {
                        this.SerbestFatura.Earchiveakayit = false
                        this.SerbestFatura.Efaturakayit = false
                        this.SerbestFatura.KagitFatura = true
                    }
                }

                var params1 = {
                    CompanyCode: credentials.SirketKodu,
                    PassiveControl: true,

                }

                if (this.SerbestFatura.Efaturakayit == true) {

                    if (this.$route.query.islem != "yenigelenevrak" && this.$route.query.islem != "gelenevrak") {
                        this.gibserigoster = true;
                    }

                    this.$http.post(auth.API_URL + 'api/Definitions/GibSerialList', params1, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {
                        this.gibseri = response.body
                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable'
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable'
                            this.snackbar = true
                        }
                    })

                } else if (this.SerbestFatura.Earchiveakayit == true) {

                    if (this.$route.query.islem != "yenigelenevrak" && this.$route.query.islem != "gelenevrak") {
                        this.gibserigoster = true;
                    }

                    this.$http.post(auth.API_URL + 'api/Definitions/GibSerialEarchiveList', params1, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {
                        this.gibseri = response.body
                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable'
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable'
                            this.snackbar = true
                        }
                    })

                } else if (this.SerbestFatura.KagitFatura == true) {
                    this.gibserigoster = false;
                }

            }, (response) => {
                if (response.status === 0) {
                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true
                } else {
                    this.text1 = response.statusText
                    this.snackbar = true
                }
            })

        },
        guncelle: guncelle,
        satirekle: satirekle,
        ekle: ekle,
        getDateNow: getDateNow,
        getDateNow1: getDateNow1,
        toDateformat: toDateformat,
        Kaydet: Kaydet,
        satirkaydet: satirkaydet,
        kdvhesapla: kdvhesapla,
        iskontohesapla: iskontohesapla,
        iskontooranhesapla: iskontooranhesapla,
        Tevkifatkdvhesapla: Tevkifatkdvhesapla,
        anatevkifatkdvkontrol: anatevkifatkdvkontrol,
        anatevkifatiptal: anatevkifatiptal,
        kurgetir: kurgetir,
        tutardetayhesaplar: tutardetayhesaplar,
        earsivbilgigir: earsivbilgigir,
        FaturaGuncelle: FaturaGuncelle,
        faturasil: faturasil,
        iadeFaturaKayit: iadeFaturaKayit,
        faturabilgidegistir: faturabilgidegistir
    },
    beforeMount: beforeMount,
    components: {
        'parainput': parainput,
        'dovizinput': dovizinput,
        'yuzdeinput': yuzdeinput,
        'tarihcomp': tarihcomp,
        referansmerkezicomp,
        masrafmerkezicomp,
        reportbrosablon,
        geneltiplist,
        yetkidialog,
        onaydialog,
        muhasebekoducomp,
        cariaracomp,
        snackbarcomp
    },
    watch: {
        'SerbestFatura.FaturaNo': function (v) {
            if (v.length == 1) {
                if (v == 0) {
                    this.SerbestFatura.FaturaNo = []
                }
            }
        },
        'SerbestFatura.Dovizli': function (val) {
            this.dizayngetir();
        },
        'SerbestFatura.FaturaTip': function (val) {

            if (val == 1) {

                this.$refs.onaydialog.open(
                    this.$t('Details-regarding-return-invoice-will-entered-after-save-update-process'), 2).then(
                    sonuc => {

                        if (sonuc == true) {

                        }
                    });
            }
        },
        'SerbestFatura.Cari.Kod': function (kod) {
            if (kod != null) {
                this.cariislemler();
            }
        },
        'SerbestFatura.Doviz.DovizKod': function (dovizkod) {
            if (dovizkod != null) {
                if (this.SerbestFatura.Kur == 0) {
                    this.kurgetir('watch');
                }
            }
        },

        'SerbestFatura.EarsivBilgi.GonderimSekli': function (kod) {
            this.gonderimsekli.forEach(element => {
                if (kod == element.value) {

                    this.gonderimlabel = element.text
                }
            });

        },
        'SerbestFatura.EarsivBilgi.InternetSatis': function (kod) {

            this.odemesekli.forEach(element => {
                if (kod == element.value) {
                    this.internetsatislabel = element.text
                }
            });

        },
        'SerbestFatura.EarsivBilgi.WebAdresi': function (kod) {

            this.webadresleri.forEach(element => {
                if (kod == element.ID) {
                    this.webadresilabel = element.Aciklama
                }
            });

        },
        'SerbestFatura.EarsivBilgi.OdemeSekli': function (kod) {

            this.odemesekli1.forEach(element => {
                if (kod == element.value) {
                    this.odemeseklilabel = element.text
                }
            });

        },

        'SerbestFatura.EarsivBilgi.OdemeSekliAciklama': function (kod) {

            this.odemesekilleri.forEach(element => {
                if (kod == element.ID) {
                    this.odemesekliaciklamalabel = element.Aciklama
                }
            });

        },
        'SerbestFatura.EarsivBilgi.OdemeAraci': function (kod) {

            this.odemearaci.forEach(element => {
                if (kod == element.ID) {
                    this.odemearacilabel = element.Aciklama
                }
            });

        },

        // 'SerbestFaturaDetay.BirimFiyat': function () {
        //     if (this.SerbestFaturaDetay.Miktar > 0 && this.SerbestFaturaDetay.BirimFiyat >= 0) {
        //         this.SerbestFaturaDetay.Tutar = this.SerbestFaturaDetay.Miktar * this.SerbestFaturaDetay.BirimFiyat
        //     } else {
        //         this.SerbestFaturaDetay.Tutar = 0
        //     }
        // },
        'SerbestFaturaDetay.Miktar': function () {
                if(this.guncelleMiktarKontrol != 0 || this.satirkaydetbuton){
                    if (this.SerbestFaturaDetay.Miktar > 0 && this.SerbestFaturaDetay.BirimFiyat >= 0) {
                        this.SerbestFaturaDetay.Tutar = this.SerbestFaturaDetay.Miktar * this.SerbestFaturaDetay.BirimFiyat
                    } else {
                        this.SerbestFaturaDetay.Tutar = 0
                    }
                }else{
                    this.guncelleMiktarKontrol = 1;
                }

        },
        'SerbestFatura.EarsivBilgi.OdemeTarihi': function (deger) {
            this.odemetarihilabel = this.tarihkontrol(deger)
        },
        'SerbestFaturaDetay.Tutar': function (deger) {
            if (this.SerbestFatura.Kur != null && this.SerbestFatura.Kur != 0) {
                this.SerbestFaturaDetay.DovizTutar = this.SerbestFaturaDetay.Tutar / this.SerbestFatura.Kur
            }

            if (deger == 0) {
                this.SerbestFaturaDetay.IskontoYuzde = 0;
            }

            if (deger == 0 && this.SerbestFaturaDetay.KdvYuzde != 0) {
                this.SerbestFaturaDetay.KdvYuzde = 0
            }

            if (deger != 0 && this.SerbestFaturaDetay.KdvYuzde != 0) {
                this.kdvhesapla();
            }

        },
        // 'SerbestFaturaDetay.IskontoTutar': function (deger) {
        //     if (deger == 0 || deger == null) {

        //         this.SerbestFaturaDetay.IskontoTutar = 0
        //         this.SerbestFaturaDetay.IskontoYuzde = 0
        //     } else {
        //         console.log('1 ' + deger)
        //         this.SerbestFaturaDetay.IskontoYuzde = deger / this.SerbestFaturaDetay.Tutar * 100
        //     }
        // },
        'SerbestFaturaDetay.IskontoYuzde': function (deger) {

            if (deger == 0 || deger == null) {
                this.SerbestFaturaDetay.IskontoTutar = 0
            } else {
               this.iskontohesapla();
            }
        },
        'SerbestFaturaDetay.KdvYuzde': function (deger) {
            this.kdvhesapla();
        },
        'SerbestFaturaDetay.KdvTip': function (deger) {

            if (this.SerbestFaturaDetay.KdvYuzde != 0 && this.SerbestFaturaDetay.KdvYuzde != null)
                this.kdvhesapla();
        }

    }
}
function toFixed2(number, precision) {
        var multiplier = Math.pow(10, precision + 1),
            wholeNumber = Math.floor(number * multiplier);
        return Math.round(wholeNumber / 10) * 10 / multiplier;
    }
function tutardetayhesaplar() {
    
    if (this.SerbestFatura.Kur != null && this.SerbestFatura.Kur != 0 && this.SerbestFatura.Kur != '' && this
        .SerbestFaturaDetay
        .Tutar != 0) {
        this.SerbestFaturaDetay.DovizTutar = this.SerbestFaturaDetay.Tutar / this.SerbestFatura.Kur
    }

    if (this.SerbestFaturaDetay.IskontoYuzde != null && this.SerbestFaturaDetay.IskontoYuzde != '') {

        var params1 = {
            Tutar: this.SerbestFaturaDetay.Tutar,
            IskontoOran: this.SerbestFaturaDetay.IskontoYuzde
        }

        this.$http.post(auth.API_URL + 'api/Helpers/GetDiscountAmount', params1, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            this.SerbestFaturaDetay.IskontoTutar = response.body.IskontoTutar
        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable-Iskonto Hesapla'
                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable-Iskonto Hesapla'
                this.snackbar = true
            }
        })
    } else {
        this.SerbestFaturaDetay.KdvTip != null
        this.SerbestFaturaDetay.IskontoYuzde = 0
        this.SerbestFaturaDetay.IskontoTutar = 0
    }

    if (this.SerbestFaturaDetay.IskontoTutar != null && this.SerbestFaturaDetay.IskontoTutar != '' && this
        .SerbestFaturaDetay
        .KdvYuzde != null && this.SerbestFaturaDetay.KdvYuzde != '') {
        var params1 = {
            KdvTip: this.SerbestFaturaDetay.KdvTip,
            Tutar: this.SerbestFaturaDetay.Tutar,
            IskontoTutar: this.SerbestFaturaDetay.IskontoTutar,
            KdvOran: this.SerbestFaturaDetay.KdvYuzde
        }

        this.$http.post(auth.API_URL + 'api/Helpers/GetTaxAmount', params1, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            this.SerbestFaturaDetay.KdvTutar = response.body.KdvTutar
        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable-Kdv Hesapla'
                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable-Kdv Hesapla'
                this.snackbar = true
            }
        })
    } else {
        this.SerbestFaturaDetay.KdvYuzde = 0
        this.SerbestFaturaDetay.KdvTutar = 0
    }

    if (this.SerbestFaturaDetay.TevkifatDetayOran != null && this.SerbestFaturaDetay.TevkifatDetayOran != '' && this
        .SerbestFaturaDetay
        .KdvTutar != '' && this.SerbestFaturaDetay.KdvTutar != null && this.detaytevkifat == true) {

        var params1 = {
            TevkifatOran: this.SerbestFaturaDetay.TevkifatDetayOran,
            KdvTutar: this.SerbestFaturaDetay.KdvTutar
        }

        this.$http.post(auth.API_URL + 'api/Helpers/GetWithHoldingAmount', params1, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            this.SerbestFaturaDetay.TevkifatDetayTutar = response.body.TevkifatTutar
        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable-Iskonto Hesapla'
                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable-Iskonto Hesapla'
                this.snackbar = true
            }
        })
    } else {
        this.SerbestFaturaDetay.TevkifatDetayOran = '0.0'
    }

}

function kurgetir(val) {

    var params1 = {
        Tarih: this.SerbestFatura.Tarih,
        DovizKod: this.SerbestFatura.Doviz.DovizKod
    }

    this.$http.post(auth.API_URL + 'api/Definitions/GetWebRate', params1, {
        headers: auth.getAuthCompaniesInfo()
    }).then((response) => {
          if(response.body == 0.0){
            this.SerbestFatura.Kur = 1
          }else{
           this.SerbestFatura.Kur = response.body
          }
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-Iskonto Hesapla'
            this.snackbar = true
        } else {
            this.text1 = 'Service Unavailable-Iskonto Hesapla'
            this.snackbar = true
        }
    })

}

function anatevkifatkdvkontrol() {
    if (this.SerbestFatura.TevkivatKdv != 0 && this.SerbestFatura.TevkivatKdv != null && this.SerbestFatura
        .TevkivatKdv !=
        '') {
        if (this.SerbestFaturaDetay.TevkifatDetayOran != 0 && this.SerbestFaturaDetay.TevkifatDetayOran != null && this
            .SerbestFaturaDetay
            .TevkifatDetayOran != '') {

            this.text1 = this.$t('Deduction-Rate-Selected-Free-Invoice-Detail-Screen')
            this.snackbar = true
            this.SerbestFatura.TevkivatKdv = null

        } else {

            this.detaytevkifat = false
            this.SerbestFaturaDetay.TevkifatDetayOran = 0
            this.SerbestFaturaDetay.TevkifatDetayTutar = 0
        }

    } else {
        this.detaytevkifat = true
    }
}

function anatevkifatiptal() {

    if (this.SerbestFatura.TevkivatKdv === 0 || this.SerbestFatura.TevkivatKdv === null || this.SerbestFatura
        .TevkivatKdv ===
        '') {
        this.detaytevkifat = true
    }
}

function Tevkifatkdvhesapla() {

    var tevkifatTutar = this.SerbestFaturaDetay.KdvTutar * this.SerbestFaturaDetay.TevkifatDetayOran;
    
    tevkifatTutar = tevkifatTutar.toFixed(2);
    this.SerbestFaturaDetay.TevkifatDetayTutar = parseFloat(tevkifatTutar);
    console.log(this.SerbestFaturaDetay.TevkifatDetayTutar);
}

function satirekle() {
    this.SerbestFaturaDetay.Referans.Kod = null
    this.satirdialog = true
    this.satirkaydetbuton = true
    this.satirguncellebuton = false
    this.SerbestFaturaDetay.MuhasebeKodu = ''
    this.SerbestFaturaDetay.MuhasebeKodu = ''
    this.SerbestFaturaDetay.Aciklama = ''
    this.SerbestFaturaDetay.LineNote = ''
    this.SerbestFaturaDetay.Masraf.Code = null
    this.SerbestFaturaDetay.Miktar = ''
    this.SerbestFaturaDetay.Birim = ''
    this.SerbestFaturaDetay.BirimFiyat = 0
    this.SerbestFaturaDetay.Tutar = 0
    this.SerbestFaturaDetay.DovizTutar = 0
    this.SerbestFaturaDetay.IskontoYuzde = 0
    this.SerbestFaturaDetay.IskontoTutar = 0
    this.SerbestFaturaDetay.KdvTip = 'D'
    this.SerbestFaturaDetay.KdvYuzde = 0
    this.SerbestFaturaDetay.KdvTutar = 0
    this.SerbestFaturaDetay.KdvMuhKodu = ''
    this.SerbestFaturaDetay.IskMuhKodu = ''
    this.SerbestFaturaDetay.KdvKodu = ''
    this.SerbestFaturaDetay.IstisnaKodu = ''
    this.SerbestFaturaDetay.TevkifatKodu = ''
    this.SerbestFaturaDetay.Tip = ''
    this.SerbestFaturaDetay.TevkifatDetayTutar = 0
    this.SerbestFaturaDetay.TevkifatDetayOran = ''
    this.SerbestFaturaDetay.TeslimBilgileri.SokakAdi = ''
    this.SerbestFaturaDetay.TeslimBilgileri.BinaAdi = ''
    this.SerbestFaturaDetay.TeslimBilgileri.BinaNo = ''
    this.SerbestFaturaDetay.TeslimBilgileri.TeslimSehir = ''
    this.SerbestFaturaDetay.TeslimBilgileri.TeslimPostaKodu = ''
    this.SerbestFaturaDetay.TeslimBilgileri.TeslimUlke = ''
    this.SerbestFaturaDetay.TeslimBilgileri.TeslimSarti = ''
    this.SerbestFaturaDetay.TeslimBilgileri.GTIPNo = ''
    this.SerbestFaturaDetay.TeslimBilgileri.TransferKodu = ''
    this.SerbestFaturaDetay.TeslimBilgileri.KabinNo = ''
    this.SerbestFaturaDetay.TeslimBilgileri.KabinAdedi = ''
    this.SerbestFaturaDetay.TeslimBilgileri.KabinCinsi = ''
    this.SerbestFaturaDetay.TeslimBilgileri.TeslimOdeme = ''
}

function satirkaydet() {

    var islem = false
    
    if (this.$route.query.islem == "yenigelenevrak" )
    {
        islem=true;
        if (this.SerbestFaturaDetay.KdvYuzde == 0)
        {
            this.SerbestFaturaDetay.KdvKodu = '0015'
        }
    }
    else
    {
        if (this.SerbestFaturaDetay.KdvYuzde == 0) {

this.SerbestFaturaDetay.KdvKodu = '0015'

if (this.SerbestFaturaDetay.IstisnaKodu != null && this.SerbestFaturaDetay.IstisnaKodu != '') {

    if ((this.SerbestFatura.TevkivatKdv != null && this.SerbestFatura.TevkivatKdv != '') || (this
            .SerbestFaturaDetay
            .TevkifatDetayOran != '' && this.SerbestFaturaDetay.TevkifatDetayOran != null)) {

        if (this.SerbestFaturaDetay.TevkifatKodu != null && this.SerbestFaturaDetay.TevkifatKodu != '') {
            islem = true
        } else {
            this.text1 = 'Tevkifat Kodunu boş geçemezsiniz.'
            this.snackbar = true
            islem = false
        }
    } else {
        islem = true
    }
} else {
    islem = false
    this.text1 = this.$t('Please-fill-in-the-required-fields.')
    this.snackbar = true
}
} else {

if (this.SerbestFaturaDetay.KdvKodu != null && this.SerbestFaturaDetay.KdvKodu != '') {

    if ((this.SerbestFatura.TevkivatKdv != null && this.SerbestFatura.TevkivatKdv != '') || (this
            .SerbestFaturaDetay
            .TevkifatDetayOran != '' && this.SerbestFaturaDetay.TevkifatDetayOran != null)) {

        if (this.SerbestFaturaDetay.TevkifatKodu != null && this.SerbestFaturaDetay.TevkifatKodu != '') {
            islem = true
        } else {
            this.text1 = this.$t('Please-fill-in-the-required-fields.')
            this.snackbar = true
            islem = false
        }
    } else {
        islem = true
    }

} else {
    this.text1 = this.$t('Please-fill-in-the-required-fields.')
    this.snackbar = true
    islem = false

}

}
    }

 

    if (islem == true) {
        this.guncelleMiktarKontrol = 0;

        if (this.SerbestFaturaDetay.DovizTutar > 0) {
            var n = this.SerbestFaturaDetay.DovizTutar
            this.SerbestFaturaDetay.DovizTutar = n.toFixed(4)

        }

        var satir = {
            TeslimBilgileri: {
                SokakAdi: this.SerbestFaturaDetay.TeslimBilgileri.SokakAdi,
                BinaAdi: this.SerbestFaturaDetay.TeslimBilgileri.BinaAdi,
                BinaNo: this.SerbestFaturaDetay.TeslimBilgileri.BinaNo,
                TeslimSehir: this.SerbestFaturaDetay.TeslimBilgileri.TeslimSehir,
                TeslimPostaKodu: this.SerbestFaturaDetay.TeslimBilgileri.TeslimPostaKodu,
                TeslimUlke: this.SerbestFaturaDetay.TeslimBilgileri.TeslimUlke,
                TeslimSarti: this.SerbestFaturaDetay.TeslimBilgileri.TeslimSarti,
                GTIPNo: this.SerbestFaturaDetay.TeslimBilgileri.GTIPNo,
                TransferKodu: this.SerbestFaturaDetay.TeslimBilgileri.TransferKodu,
                KabinNo: this.SerbestFaturaDetay.TeslimBilgileri.KabinNo,
                KabinAdedi: this.SerbestFaturaDetay.TeslimBilgileri.KabinAdedi,
                KabinCinsi: this.SerbestFaturaDetay.TeslimBilgileri.KabinCinsi,
                TeslimOdeme: this.SerbestFaturaDetay.TeslimBilgileri.TeslimOdeme
            },
            MuhasebeKodu: this.SerbestFaturaDetay.MuhasebeKodu,
            Aciklama: this.SerbestFaturaDetay.Aciklama,
            Referans: {
                Kod: this.SerbestFaturaDetay.Referans.Kod
            },
            Masraf: {
                Code: this.SerbestFaturaDetay.Masraf.Code
            },
            Miktar: this.SerbestFaturaDetay.Miktar,
            LineNote: this.SerbestFaturaDetay.LineNote,
            Birim: this.SerbestFaturaDetay.Birim,
            BirimFiyat: this.SerbestFaturaDetay.BirimFiyat,
            Tutar: this.SerbestFaturaDetay.Tutar,
            TevkifatDetayTutar: this.SerbestFaturaDetay.TevkifatDetayTutar,
            DovizTutar: this.SerbestFaturaDetay.DovizTutar,
            TevkifatDetayOran: this.SerbestFaturaDetay.TevkifatDetayOran,
            IskontoYuzde: this.SerbestFaturaDetay.IskontoYuzde,
            IskontoTutar: this.SerbestFaturaDetay.IskontoTutar,
            KdvKodu: this.SerbestFaturaDetay.KdvKodu,
            KdvMuhKodu: this.SerbestFaturaDetay.KdvMuhKodu, //
            IskMuhKodu: this.SerbestFaturaDetay.IskMuhKodu, //
            KdvTutar: this.SerbestFaturaDetay.KdvTutar,
            KdvTip: this.SerbestFaturaDetay.KdvTip,
            KdvYuzde: this.SerbestFaturaDetay.KdvYuzde,
            IstisnaKodu: this.SerbestFaturaDetay.IstisnaKodu,
            TevkifatKodu: this.SerbestFaturaDetay.TevkifatKodu,
            Tip: this.SerbestFaturaDetay.Tip,
            AdresBilgi: {
                Unvani: null,
                Unvani2: null,
                Adres1: null,
                Adres2: null,
                IlceSehir: null,
                Email: null,
                VergiDairesi: null,
                VergiNo: null,
                TcKimlikNo: null,
                Adi: null,
                Soyadi: null,
                TUnvani: null,
                DigerAdi: null,
                OnAdiEki: null
            },
            EfaturaDetayBilgileri: {
                SiparisID: null,
                SiparisTarihi: null
            },
            AdresBilgi: {
                Unvani: null,
                Unvani2: null,
                Adres1: null,
                Adres2: null,
                IlceSehir: null,
                Email: null,
                VergiDairesi: null,
                VergiNo: null,
                TcKimlikNo: null,
                Adi: null,
                Soyadi: null,
                TUnvani: null,
                DigerAdi: null,
                OnAdiEki: null
            }
        }

        if (this.detaytevkifat === false) {

            var params1 = {
                TevkifatOran: this.SerbestFatura.TevkivatKdv,
                KdvTutar: this.SerbestFaturaDetay.KdvTutar
            }

            this.$http.post(auth.API_URL + 'api/Helpers/GetWithHoldingAmount', params1, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.SerbestFatura.Tutarlar.TevkifatKdv = this.SerbestFatura.Tutarlar.TevkifatKdv + response.body
                    .TevkifatTutar
                this.SerbestFatura.Tutarlar.Iskonto = this.SerbestFatura.Tutarlar.Iskonto + satir.IskontoTutar
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-Tevkifat Hesapla'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable-Tevkifat Hesapla'
                    this.snackbar = true
                }
            })

        } else {

            this.SerbestFatura.Tutarlar.TevkifatKdv = this.SerbestFatura.Tutarlar.TevkifatKdv + satir.TevkifatDetayTutar
            this.SerbestFatura.Tutarlar.Iskonto = this.SerbestFatura.Tutarlar.Iskonto + satir.IskontoTutar
        }

        this.SerbestFatura.Tutarlar.ToplamTutar = this.SerbestFatura.Tutarlar.ToplamTutar + satir.Tutar

        this.SerbestFatura.Tutarlar.Kdv = this.SerbestFatura.Tutarlar.Kdv + satir.KdvTutar

        // this.SerbestFatura.Tutarlar.FaturaToplam = this.SerbestFatura.Tutarlar.ToplamTutar -
        //   this.SerbestFatura.Tutarlar.Iskonto - this.SerbestFatura.Tutarlar.TevkifatKdv

        this.satiritems.push(satir);

        this.satirdialog = false
        this.faturatoplambul();

    }

}

function iadeFaturaKayit() {

    if (this.$refs.formiade.validate()) {
        this.loadingdialog = true;
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.SerbestFatura.SirketKodu = credentials.SirketKodu
        this.SerbestFatura.Detay = this.satiritems
        var params = this.SerbestFatura

        this.$http.post(auth.API_URL + 'api/Invoice/FreeInvoiceAdd', params, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            if (response.body.Status === true) {

                this.iadedialog = false

                 this.text1 = this.$t(response.body.ResponseMessage)
                this.snackbar = true
                

                if (this.nefaturasi == 'serbest') {
                    var url = '#/fatura/serbestfatura/id?' + 'ft=' + this.SerbestFatura.Tarih +
                        '&ck=' + this
                        .SerbestFatura.Cari.Kod + '&et=' + 'SF' + '&es=' +
                        this.SerbestFatura.FaturaSeri + '&en=' + this.SerbestFatura.FaturaNo + '&ner=' +
                        "X" +
                        '&sb=' + true + '&islem=get'
                    window.open(url, '_self')
                } else {
                    var url = '#/fatura/serbestfatura/id?' + 'ft=' + this.SerbestFatura.Tarih +
                        '&ck=' + this
                        .SerbestFatura.Cari.Kod + '&et=' + 'SF' + '&es=' +
                        this.SerbestFatura.FaturaSeri + '&en=' + this.SerbestFatura.FaturaNo + '&ner=' +
                        "X" +
                        '&sb=' + true + '&islem=gelenevrak'
                    window.open(url, '_self')
                }
                setTimeout(function () {
                    window.location.reload(false);
                    this.loadingdialog = false;
                }.bind(this), 5000)

            } else {
                 this.text1 = this.$t(response.body.ResponseMessage)
                this.snackbar = true
            }
        }, (response) => {
            if (response.status === 0) {
                 this.text1 = this.$t(response.body.ResponseMessage)
                this.snackbar = true
            } else {
                this.text1 = response.body.ExceptionMessage
                this.snackbar = true
            }
        })

    }

}

//kaydetme işlemi
function Kaydet() {

    if(this.counter == 0){
        this.counter = 12;

    var islemok = false

    if (this.nefaturasi == 'serbest') {

        if (parseFloat(this.SerbestFatura.Tutarlar.FaturaToplam) > 0) {
            islemok = true
        } else {
            this.text1 = this.$t('You-cannot-enter-invoices-with-amounts-0-and-below.')
            this.snackbar = true
            islemok = false
            this.counter = 0
        }
    }

    if (this.nefaturasi == 'gelen') {
        islemok = true

        var yedekEFaturaShowID = {
            EFaturaID: null,
            EFaturaGuid: null,
            FaturaStatus: null,
            PdfID: null,
            DizaynID: null,
            XsltID: null
        }
        this.SerbestFatura.EFaturaShowID = yedekEFaturaShowID
    }

    if (islemok == true) {

        this.$validator.validateAll().then((result) => {

            if (this.SerbestFatura.EFaturaShowID.DizaynID != 0) {

                if (result) {

                    if (this.satiritems.length > 0) {

                        if (this.nefaturasi == 'gelen' || this.nefaturasi == 'yenigelen') {
                            this.SerbestFatura.Serbest = false
                        } else {
                            this.SerbestFatura.Serbest = true
                        }

                        if (this.SerbestFatura.FaturaTip == 0) {

                            this.SerbestFatura.IadeFaturaBilgi.IstinadenFaturaTarihi = null
                            this.SerbestFatura.IadeFaturaBilgi.IstinadenFaturaSeri = null
                            this.SerbestFatura.IadeFaturaBilgi.IstinadenFaturaNo = null
                            this.SerbestFatura.IadeFaturaBilgi.IadeNedeni = null

                            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
                            this.SerbestFatura.SirketKodu = credentials.SirketKodu
                            this.SerbestFatura.Detay = this.satiritems
                            var params = this.SerbestFatura
                            this.loadingdialog = true;

                            this.$http.post(auth.API_URL + 'api/Invoice/FreeInvoiceAdd', params, {
                                headers: {
                                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                                }
                            }).then((response) => {
                                if (response.body.Status === true) {
                                     this.text1 = this.$t(response.body.ResponseMessage)
                                    this.snackbar = true
                                    if (this.nefaturasi == 'serbest') {
                                        let url = '#/fatura/serbestfatura/id?' + 'ft=' + this.SerbestFatura.Tarih +
                                            '&ck=' + this
                                            .SerbestFatura.Cari.Kod + '&et=' + 'SF' + '&es=' +
                                            this.SerbestFatura.FaturaSeri + '&en=' + this.SerbestFatura.FaturaNo + '&ner=' +
                                            "X" +
                                            '&sb=' + true + '&islem=get'
                                        window.open(url, '_self')
                                    } else {
                                        let url = '#/fatura/serbestfatura/id?' + 'ft=' + this.SerbestFatura.Tarih +
                                            '&ck=' + this
                                            .SerbestFatura.Cari.Kod + '&et=' + 'SF' + '&es=' +
                                            this.SerbestFatura.FaturaSeri + '&en=' + this.SerbestFatura.FaturaNo + '&ner=' +
                                            "X" +
                                            '&sb=' + true + '&islem=gelenevrak'
                                        window.open(url, '_self')
                                    }
                                    setTimeout(function () {
                                        window.location.reload(false);
                                        this.loadingdialog = false;

                                    }.bind(this), 5000)

                                } else {
                                     this.text1 = this.$t(response.body.ResponseMessage)
                                    this.snackbar = true
                                    this.counter = 0
                                    this.loadingdialog = false;
                                }
                            }, (response) => {
                                if (response.status === 0) {
                                     this.text1 = this.$t(response.body.ResponseMessage)
                                    this.snackbar = true
                                    this.counter = 0
                                    this.loadingdialog = false;
                                } else {
                                    this.text1 = response.body.ExceptionMessage
                                    this.snackbar = true
                                    this.counter = 0
                                    this.loadingdialog = false;
                                }
                            })

                        } else {
                            this.iadedialog = true
                            this.SerbestFatura.IadeFaturaBilgi.IstinadenFaturaTarihi = this.SerbestFatura.Tarih
                            this.SerbestFatura.IadeFaturaBilgi.IstinadenFaturaSeri = this.SerbestFatura.FaturaSeri
                            this.SerbestFatura.IadeFaturaBilgi.IstinadenFaturaNo = this.SerbestFatura.FaturaNo
                            this.SerbestFatura.IadeFaturaBilgi.IadeNedeni = null
                             this.counter = 0
                             this.loadingdialog = false;

                        }

                    } else {
                        this.text1 = this.$t('Line-Entry')
                        this.snackbar = true
                        this.counter = 0
                        this.loadingdialog = false;
                    }
                } else {
                    this.text1 = this.$t('Please-fill-in-the-required-fields.')
                    this.snackbar = true
                    this.counter = 0
                    this.loadingdialog = false;
                }
            } else {
                this.text1 = this.$t('Please-select-invoice-design')
                this.snackbar = true
                this.counter = 0
                this.loadingdialog = false;
            }

        })
    }

    }
}

function FaturaGuncelle() {

    var control = false

    if (this.nefaturasi == 'serbest') {

        control = true
    } else {

        control = false
    }

    if (this.nefaturasi == 'gelen') {
        control = true

        var yedekEFaturaShowID = {
            EFaturaID: null,
            EFaturaGuid: null,
            FaturaStatus: null,
            PdfID: null,
            DizaynID: null,
            XsltID: null
        }

        this.SerbestFatura.EFaturaShowID = yedekEFaturaShowID
    } else {
        control = false
    }

    if (control = true) {
        this.$validator.validateAll().then((result) => {

            if (result) {

                if (this.satiritems.length > 0) {

                    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                    if (this.nefaturasi == 'gelen' || this.nefaturasi == 'yenigelen') {
                        this.SerbestFatura.Serbest = false
                    } else {
                        this.SerbestFatura.Serbest = true
                    }

                    this.SerbestFatura.SirketKodu = credentials.SirketKodu

                    this.SerbestFatura.Update = true

                    this.SerbestFatura.Detay = this.satiritems

                    var params = this.SerbestFatura

                    if (this.SerbestFatura.FaturaTip == 0) {
                         this.loadingdialog = true;
                        this.$http.post(auth.API_URL + 'api/Invoice/FreeInvoiceAdd', params, {
                            headers: {
                                'Authorization': 'Bearer ' + auth.getAuthHeader()
                            }
                        }).then((response) => {
                            if (response.body.Status === true) {
                                 this.text1 = this.$t(response.body.ResponseMessage)
                                this.snackbar = true
                                this.SerbestFatura = response.body.Fatura;
                                 this.loadingdialog = false;

                            } else {
                                 this.text1 = this.$t(response.body.ResponseMessage)
                                this.snackbar = true
                                this.loadingdialog = false;

                            }
                        }, (response) => {
                            if (response.status === 0) {
                                this.text1 = response.body.ExceptionMessage
                                this.snackbar = true
                                this.loadingdialog = false;
                            } else {
                                this.text1 = response.body.ExceptionMessage
                                this.snackbar = true
                                this.loadingdialog = false;
                            }
                        })

                    } else {
                        this.iadedialog = true

                    }

                } else {
                    this.text1 = this.$t('Line-Entry')
                    this.snackbar = true
                }

            } else {
                this.text1 = this.$t('Please-fill-in-the-required-fields.')
                this.snackbar = true
            }

        })

    }
}

function faturabilgidegistir() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var opsiyonparams = {
        IskontoBas: false,
        DovizBas: false,
        OdemeBas: false,
        YolcuBas: false,
        CariBasma: false,
        Deleted: false,
    }

    if (this.islemturu == 0) {

        if (this.ChangeFaturaNo != null && this.ChangeFaturaNo != '') {

            var changeparams = {
                ChangeType: false, // false : numara, true : tarih
                YeniEvrakno: this.ChangeFaturaNo,
                YeniTarih: null
            }

            var params = {
                SirketKodu: credentials.SirketKodu,
                Tarih: this.SerbestFatura.Tarih,
                CariKod: this.SerbestFatura.Cari.Kod,
                EvrakTipi: null,
                EvrakSeri: this.SerbestFatura.FaturaSeri,
                Evrakno: this.SerbestFatura.FaturaNo,
                Nereden: 'X',
                Serbest: true,
                Opsiyonlar: opsiyonparams,
                ChangeInfo: changeparams,
                FaturaUnique:this.SerbestFatura.FaturaUnique
            }

            this.$http.post(auth.API_URL + 'api/Invoice/FreeInvoiceChange', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                if (response.body.Status === true) {
                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true
                    this.SerbestFatura.FaturaNo = this.ChangeFaturaNo
                    setTimeout(function () {
                      this.dialogdegistir = false
                      var url = '#/fatura/faturalistesi'
                      window.open(url, '_self')
                    }.bind(this), 1500)

                } else {
                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true
                }
            }, (response) => {
                if (response.status === 0) {
                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true
                    this.dialogsor = false
                } else {
                    this.text1 = response.statusText
                    this.snackbar = true
                    this.dialogsor = false
                }
            })
        } else {
            this.text1 = this.$t('Please-fill-in-the-required-fields.')
            this.snackbar = true
        }

    }

    if (this.islemturu == 1) {

        if (this.ChangeTarih != null && this.ChangeTarih != '' && typeof (this.ChangeTarih) != 'undefined') {

            var changeparams = {
                ChangeType: true, // false : numara, true : tarih
                YeniEvrakno: null,
                YeniTarih: this.ChangeTarih
            }

            var params = {
                SirketKodu: credentials.SirketKodu,
                Tarih: this.SerbestFatura.Tarih,
                CariKod: this.SerbestFatura.Cari.Kod,
                EvrakTipi: null,
                EvrakSeri: this.SerbestFatura.FaturaSeri,
                Evrakno: this.SerbestFatura.FaturaNo,
                Nereden: 'X',
                Serbest: true,
                Opsiyonlar: opsiyonparams,
                ChangeInfo: changeparams,
                FaturaUnique:this.SerbestFatura.FaturaUnique,
            }

            this.$http.post(auth.API_URL + 'api/Invoice/FreeInvoiceChange', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                if (response.body.Status === true) {
                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true
                    this.SerbestFatura.Tarih = this.ChangeTarih
                    setTimeout(function () {
                      this.dialogdegistir = false
                      var url = '#/fatura/faturalistesi'
                      window.open(url, '_self')
                    }.bind(this), 1500)
                } else {
                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true
                }
            }, (response) => {
                if (response.status === 0) {
                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true
                    this.dialogsor = false

                } else {
                    this.text1 = response.statusText
                    this.snackbar = true
                    this.dialogsor = false

                }
            })

        }
    } else {
        this.text1 = this.$t('Please-fill-in-the-required-fields.')
        this.snackbar = true
    }

}

function faturasil() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
        SirketKodu: credentials.SirketKodu,
        Tarih: this.SerbestFatura.Tarih,
        CariKod: this.SerbestFatura.Cari.Kod,
        EvrakTipi: null,
        EvrakSeri: this.SerbestFatura.FaturaSeri,
        Evrakno: this.SerbestFatura.FaturaNo,
        Nereden: 'X',
        Serbest: true,
        FaturaUnique:this.SerbestFatura.FaturaUnique,
    }

    this.$http.post(auth.API_URL + 'api/Invoice/FreeInvoiceDelete', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        if (response.body.Status === true) {
             this.text1 = this.$t(response.body.ResponseMessage) + ' fatura listesine yönlendiriliyorsunuz...'
            this.snackbar = true
            this.dialogsor = false

            if (this.$route.query.islem != "yenigelenevrak" && this.$route.query.islem != "gelenevrak") {
                setTimeout(function () {

                    var url = '#/fatura/faturalistesi'
                    window.open(url, '_self')
                }.bind(this), 5000)
            } else {
                setTimeout(function () {

                    var url = '#/fatura/gelenfaturalistesi'
                    window.open(url, '_self')
                }.bind(this), 5000)
            }

        } else {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
        }
    }, (response) => {
        if (response.status === 0) {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
            this.dialogsor = false

        } else {
            this.text1 = response.statusText
            this.snackbar = true
            this.dialogsor = false

        }
    })
}

function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
        dd = '0' + dd
    }

    if (mm < 10) {
        mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
}

function iskontooranhesapla() {
    //burada apiye gitmek gerekli datadan parametre cekilip hesaplama yapiliyor
    var params1 = {
        Tutar: this.SerbestFaturaDetay.Tutar,
        IskontoTutar: this.SerbestFaturaDetay.IskontoTutar
    }

    this.$http.post(auth.API_URL + 'api/Helpers/GetDiscountRate', params1, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.SerbestFaturaDetay.IskontoTutar = response.body.IskontoOran
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-Iskonto Hesapla'
            this.snackbar = true
        } else {
            this.text1 = 'Service Unavailable-Iskonto Hesapla'
            this.snackbar = true
        }
    })
}

function iskontohesapla() {
    var iskontoTutar =   this.SerbestFaturaDetay.Tutar * (this.SerbestFaturaDetay.IskontoYuzde / 100);
   
    let sayi = iskontoTutar;
let sayiStr = sayi.toString();
let ondalikKisim = sayiStr.split('.')[1];
let yuvarlanmisSayi=0;

if (ondalikKisim && ondalikKisim.length > 2) {
     yuvarlanmisSayi = Math.floor(sayi * 100) / 100;
  console.log(yuvarlanmisSayi); 
} else {
    yuvarlanmisSayi=sayi;
}
    
     this.SerbestFaturaDetay.IskontoTutar = parseFloat(yuvarlanmisSayi);

}

function kdvhesapla() {
    const detay = this.SerbestFaturaDetay;
const netTutar = detay.Tutar - detay.IskontoTutar;

let kdvTutar;

if (detay.KdvTip === "H") {
    kdvTutar = (netTutar * detay.KdvYuzde) / 100;
} else {
    kdvTutar = netTutar - (netTutar / (1 + detay.KdvYuzde / 100));
}

// Virgülden sonra en fazla 2 basamak (küsurat varsa)
let yuvarlanmisSayi = parseFloat(kdvTutar.toFixed(2));

this.SerbestFaturaDetay.KdvTutar = yuvarlanmisSayi;

//     var kdvTutar;
   
//     if(this.SerbestFaturaDetay.KdvTip == "H"){
//         kdvTutar = (this.SerbestFaturaDetay.Tutar - this.SerbestFaturaDetay.IskontoTutar) / 100 * this.SerbestFaturaDetay.KdvYuzde;  
//     }else{
//         kdvTutar = (this.SerbestFaturaDetay.Tutar - this.SerbestFaturaDetay.IskontoTutar) - ((this.SerbestFaturaDetay.Tutar - this.SerbestFaturaDetay.IskontoTutar) / (1 + (this.SerbestFaturaDetay.KdvYuzde / 100)));
//     }
   
//     let sayi = kdvTutar;
//     console.log(sayi);
// let sayiStr = sayi.toString();
// let ondalikKisim = sayiStr.split('.')[1];
// let yuvarlanmisSayi=0;

// if (ondalikKisim && ondalikKisim.length > 2 ) {
//      yuvarlanmisSayi = Math.floor(sayi * 100) / 100;
//   console.log(yuvarlanmisSayi); 
// } else {
//     yuvarlanmisSayi=sayi;
// }
    
    
//     this.SerbestFaturaDetay.KdvTutar = parseFloat(yuvarlanmisSayi);
    
}

function getDateNow1() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
        dd = '0' + dd
    }
    if (mm < 10) {
        mm = '0' + mm
    }
    today = dd + '.' + mm + '.' + yyyy
    return today
}

function beforeMount() {

}

function earsivbilgigir() {
    this.dialogearsiv = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    //web adreslerini çekelim
    var params = {
        CompanyCode: credentials.SirketKodu,
        Type: '305'
    }
    this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeList', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.webadresleri = response.body
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-web adresleri'
            this.snackbar = true
        } else {

            this.text1 = 'Service Unavailable-web adresleri'
            this.snackbar = true
        }
    })

    //ödeme şekillerini çekelim
    var params = {
        CompanyCode: credentials.SirketKodu,
        Type: '306'
    }
    this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeList', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.odemesekilleri = response.body
    }, (response) => {
        if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable-ödeme şekli'
            this.snackbar = true
        } else {
            this.text1 = 'Service Unavailable-ödeme şekli'
            this.snackbar = true
        }
    })
    // ödeme araçlarını alalalım
    var params = {
        CompanyCode: credentials.SirketKodu,
        Type: '307'
    }
    this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeList', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.odemearaci = response.body
    }, (response) => {
        if (response.status === 0) {

            this.text1 = 'Service Unavailable-ödeme aracı'
            this.snackbar = true
        } else {

            this.text1 = 'Service Unavailable-ödeme aracı'
            this.snackbar = true
        }
    })

}

function toDateformat(dateStr) {
    var parts = dateStr.split("-");
    return (parts[2] + '.' + parts[1] + '.' + parts[0]);
}

function ekle() {

    this.Current.Contract.ContractDate = this.SerbestFatura.Tarih

    var current = this.Current
    this.$http.post(auth.API_URL + 'api/Current/New', current, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        if (response.body.Status === true) {
            this.text1 = this.$t('Record-Updated')
            this.snackbar = true
        } else if (response.body.Status === false) {
            this.text1 = this.$t('Error')
            this.snackbar = true
        }
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
        } else {
            
            let data ={
            response: response,
            request: current,
            api:'Current/New',
            type:2,
            message: response.body.ExceptionMessage
            };
            this.$refs.showMessage.open(data);

        }
    })
}

function guncelle() {

    this.$validator.validateAll().then((result) => {
        if (result) {

            this.Current.Contract.ContractDate = this.SerbestFatura.Tarih
            var current = this.Current
            this.$http.post(auth.API_URL + 'api/Current/Update', current, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                if (response.body.Status === true) {
                    this.text1 =this.$t('Record-Updated')
                    this.snackbar = true
                } else if (response.body.Status === false) {
                    this.text1 = this.$t('Error')
                    this.snackbar = true
                }
            }, (response) => {
                if (response.status === 0) {
                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true
                } else {
                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true
                }
            })
        }
    })
}
</script>

<style scoped>
.outer {

    position: relative;
    display: inline-block;
    margin: 0 10px;
    padding-top: inherit+100px;

}

.inner {
    position: absolute;
    top: 104%;
    left: 50%;
    padding-block-start: 30px;
    padding-block-end: 10px;
}

.icorta {
    margin: 0px auto;
    height: 226px;
    color: #fff;
    position: absolute;
    left: 92%;
    top: 95%;
    margin-left: -110px;
    margin-top: -15px;
}

.rotate {
    -moz-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
    -webkit-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
    transform: translateX(-50%) translateY(-50%) rotate(-90deg);

}
</style>
